<script>
// https://practicetest.icbc.com/data/opkt/english.xml
const questionsFull = [
  {
    "@id": "0",
    "text": "To identify hazards in your surroundings while driving, you should",
    "answers": {
      "answer": "scan the driving environment regularly",
      "distractor_1": "only keep your eyes directly on the road ahead",
      "distractor_2": "avoid using your rear view mirrors",
      "distractor_3": "tune your radio to receive local traffic information"
    },
    "chapter": "Chapter 5: See - Think - Do",
    "source": "Do not overdrive your ability to see. You should always be able to prepare for a potential hazard instead of being taken by surprise.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "1",
    "text": "On a vehicle with AUTOMATIC transmission, when should the first and second DRIVE (D1, D2) gears be used",
    "answers": {
      "answer": "when pulling heavy loads or when going up or down very steep hills.",
      "distractor_1": "when exiting a highway.",
      "distractor_2": "when parking your vehicle.",
      "distractor_3": "when it is raining."
    },
    "chapter": "Chapter 2: You and Your Vehicle; Comparing Automatic and Standard Transmissions",
    "source": "There are two types of transmissions: automatic and standard. Both control the connection between the engine and the wheels.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers2.pdf"
    }
  },
  {
    "@id": "2",
    "text": "Which of the following is NOT part of the pre-trip check you should do EVERY time you drive?",
    "answers": {
      "answer": "Check radiator fluid and oil levels.",
      "distractor_1": "Check side and rear view mirrors are properly adjusted.",
      "distractor_2": "Check head rest and seat belts are properly adjusted.",
      "distractor_3": "Check lights and turn signals."
    },
    "chapter": "Chapter 2: You and Your Vehicle; Pre-trip Check.",
    "source": "To ensure good maintenance, you need to do a more thorough pre-trip check every few weeks.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers2.pdf"
    }
  },
  {
    "@id": "3",
    "text": "Seat belts are most effective in preventing injury when",
    "answers": {
      "answer": "the lap belt and shoulder strap are worn correctly.",
      "distractor_1": "the head rest is fully extended.",
      "distractor_2": "the seat is moved fully forward.",
      "distractor_3": "the seat is tilted back slightly."
    },
    "chapter": "Chapter 2: You and Your Vehicle; Seatbelts",
    "source": "Wearing a seatbelt significantly reduces your chance of serious injury or death in a crash.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers2.pdf"
    }
  },
  {
    "@id": "4",
    "text": "As a driver you should",
    "answers": {
      "answer": "constantly check the sides of the road and all of your mirrors, as well as the road ahead",
      "distractor_1": "carefully watch the car behind you",
      "distractor_2": "carefully watch the car ahead of you",
      "distractor_3": "rarely look in your mirrors"
    },
    "chapter": "Chapter 5: See - Think - Do; Observation",
    "source": "It is important that you pay attention to things outside your central vision. Peripheral vision allows you to see more than what is directly in front of you.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "5",
    "text": "When making a right turn, you should shoulder check to",
    "answers": {
      "answer": "make sure a cyclist or other road user is not beside you",
      "distractor_1": "make sure you are in the proper lane",
      "distractor_2": "warn the car behind of your intent to turn",
      "distractor_3": "make sure the car behind you is not too close"
    },
    "chapter": "Chapter 5: See - Think - Do; Observation",
    "source": "Whenever you plan a change in direction or road position, do a shoulder check to make sure the blind spot on that side is clear.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "6",
    "text": "The correct See-Think-Do strategy for the driver of Car A is?",
    "answers": {
      "answer": "Sees that Car B is close behind; thinks, \"I need more space.\";  slows and  gradually leaves a bigger cushion in front.",
      "distractor_1": "Sees that Car B is close behind; thinks, \"I need to get away.\"; accelerates to leave more space behind.",
      "distractor_2": "Sees there is small gap to the right of Truck C; thinks, \"I can squeeze through there.\"; accelerates and changes lanes.",
      "distractor_3": "Sees that Car B is close behind; thinks, \"I need more space.\"; brakes suddenly to scare driver of Car B."
    },
    "chapter": "Chapter 5:  See - Think - Do",
    "source": "it's a good idea to slow down slightly to increase your space in front. This way, if you have to stop, you can stop more gradually ...",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    },
    "image": {
      "@file": "images/opkt/q6.png"
    }
  },
  {
    "@id": "7",
    "text": "When do you NOT need to make a shoulder check?",
    "answers": {
      "answer": "When judging your following distance.",
      "distractor_1": "When you pull out from the side of the road.",
      "distractor_2": "When you pull over to the side of the road.",
      "distractor_3": "When you change lanes."
    },
    "chapter": "Chapter 5: See - Think - Do; Observation",
    "source": "Whenever you plan a change in direction or road position, do a shoulder check to make sure the blind spot on that side is clear.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "8",
    "text": "There is a vehicle directly in the blind spot of Car A, which one is it?",
    "answers": {
      "answer": "Car D",
      "distractor_1": "Car C",
      "distractor_2": "Car B",
      "distractor_3": "Car E"
    },
    "chapter": "Chapter 5: See - Think - Do; Observation",
    "source": "Even when your mirrors are properly adjusted, there are large areas that you can't see in your mirrors. These are called blind spots.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    },
    "image": {
      "@file": "images/opkt/q8.png"
    }
  },
  {
    "@id": "9",
    "text": "The best way to check for vehicles in the blind spots is by",
    "answers": {
      "answer": "looking over your shoulder",
      "distractor_1": "keeping clear of other vehicles",
      "distractor_2": "checking side and rearview mirrors",
      "distractor_3": "scanning for blind spots ahead of you"
    },
    "chapter": "Chapter 5: See - Think - Do; Observation",
    "source": "Whenever you plan a change in direction or road position, do a shoulder check to make sure the blind spot on that side is clear.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "10",
    "text": "Reaction time is affected most after",
    "answers": {
      "answer": "drinking alcohol",
      "distractor_1": "exercising",
      "distractor_2": "sleeping",
      "distractor_3": "working hard"
    },
    "chapter": "Chapter 7: Personal Strategies; Facts About Alcohol",
    "source": "In some cases, even small amounts of alcohol can cause a driver to be impaired.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers7.pdf"
    }
  },
  {
    "@id": "11",
    "text": "What is this cyclist going to do?",
    "answers": {
      "answer": "Stop or slow down.",
      "distractor_1": "Turn right.",
      "distractor_2": "Turn left.",
      "distractor_3": "Let you pass."
    },
    "chapter": "Chapter 5: See - Think - Do; Communication",
    "source": "This section has an illustration that shows how cyclists signal left turns, right turns, and stopping or slowing down.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    },
    "image": {
      "@file": "images/opkt/q11.png"
    }
  },
  {
    "@id": "12",
    "text": "A driver should not change lanes",
    "answers": {
      "answer": "in intersections",
      "distractor_1": "at less than 50km/h",
      "distractor_2": "at more than 80km/h",
      "distractor_3": "in hospital zones"
    },
    "chapter": "Chapter 4: Rules of the Road",
    "source": "Don't change lanes at an intersection. You could confuse other drivers and cause a crash.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    }
  },
  {
    "@id": "13",
    "text": "Unless otherwise posted, the speed limit WITHIN cities and towns is",
    "answers": {
      "answer": "50km/h",
      "distractor_1": "30km/h",
      "distractor_2": "60km/h",
      "distractor_3": "80km/h"
    },
    "chapter": "Chapter 5: See - Think - Do; Speed Control",
    "source": "Unless a sign tells you otherwise, the speed limit is 50km/h within cities and towns.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "14",
    "text": "What should the driver of Car A do?",
    "answers": {
      "answer": "Slow down to allow Car B safe entry.",
      "distractor_1": "Speed up to get ahead of merging Car B.",
      "distractor_2": "Slow down, honk, and wave Car B in.",
      "distractor_3": "Maintain speed."
    },
    "chapter": "Chapter 4: Rules of the Road; Highway or Freeway Entrances and Exits",
    "source": "When you are driving in the right lane of a freeway, other drivers may try to merge from an entrance lane. It's not always easy for them to find a safe gap.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    },
    "image": {
      "@file": "images/opkt/q14.png"
    }
  },
  {
    "@id": "15",
    "text": "Before you pull out to pass, you should",
    "answers": {
      "answer": "be able to see well ahead",
      "distractor_1": "get close to the vehicle ahead",
      "distractor_2": "wait for a signal from the driver ahead",
      "distractor_3": "speed up and watch carefully"
    },
    "chapter": "Chapter 5: See - Think - Do; Assess the Risk",
    "source": "In assessing just how risky this situation is, you should ask yourself what could happen. What if there is an unexpected obstacle just around the curve?",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "16",
    "text": "You should NOT pass another vehicle",
    "answers": {
      "answer": "when your vision is obstructed",
      "distractor_1": "on an unfamiliar road",
      "distractor_2": "on a 2-lane road at night",
      "distractor_3": "on a multi-lane one way street"
    },
    "chapter": "Chapter 5: See - Think - Do; Hazard Perception",
    "source": "Be extra cautious when anything blocks your view. Never pass when you are approaching the top of a hill.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "17",
    "text": "It is illegal to exceed the posted speed limit",
    "answers": {
      "answer": "at all times",
      "distractor_1": "except in remote or unpopulated areas",
      "distractor_2": "except when you are keeping up with traffic",
      "distractor_3": "except when passing"
    },
    "chapter": "Chapter 5: See - Think - Do; Speed Control",
    "source": "The posted speed is the maximum for ideal conditions only. Choose a lower speed if the conditions are not ideal.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "18",
    "text": "If you are behind a large vehicle or a motorcycle on a high speed road, your following distance should be at LEAST",
    "answers": {
      "answer": "3 seconds",
      "distractor_1": "4 seconds",
      "distractor_2": "2 seconds",
      "distractor_3": "6 seconds"
    },
    "chapter": "Chapter 5: See - Think - Do; Space Margins",
    "source": "Allow at least three seconds following distance when you are behind a large vehicle that could block your vision or a motorcycle that could stop very quickly.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "19",
    "text": "In bad weather or slippery conditions on high speed roads, your following distance should be at LEAST",
    "answers": {
      "answer": "4 seconds",
      "distractor_1": "2 seconds",
      "distractor_2": "6 seconds",
      "distractor_3": "8 seconds"
    },
    "chapter": "Chapter 5: See - Think - Do; Space Margins",
    "source": "Increase your following distance to three seconds on high-speed roads and to four seconds in bad weather conditions or on uneven or slippery roads.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "20",
    "text": "Pedestrians and cyclists are most at risk from vehicles because",
    "answers": {
      "answer": "they are more likely to be severely injured in a crash than car drivers and passengers",
      "distractor_1": "they are not required to follow the rules of the road",
      "distractor_2": "they are more often at fault when crashes occur",
      "distractor_3": "they are slower"
    },
    "chapter": "Chapter 6: Sharing the Road",
    "source": "Of all road users, pedestrians are among the most vulnerable. You always need to watch out for them. Pedestrians, like all road users, can be unpredictable.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "21",
    "text": "What is the most immediate danger to Cyclist A?",
    "answers": {
      "answer": "The driver of Car B may not see Cyclist A and turn into its path.",
      "distractor_1": "The pedestrian may move into Cyclist A's path.",
      "distractor_2": "The driver of Car C may drive into the back of Cyclist A.",
      "distractor_3": "The driver of Car D will turn left."
    },
    "chapter": "Chapter 6: Sharing the Road; Cyclists",
    "source": "Be aware that cyclists don't always stay on the right. To make a left turn, for instance, they need to move over to the left lane.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    },
    "image": {
      "@file": "images/opkt/q21.png"
    }
  },
  {
    "@id": "22",
    "text": "You MUST stop for a school bus",
    "answers": {
      "answer": "when its red lights are flashing",
      "distractor_1": "at all times",
      "distractor_2": "when it is carrying children",
      "distractor_3": "when it is waiting by a school"
    },
    "chapter": "Chapter 6: Sharing the Road; School buses",
    "source": "Stop whenever you see flashing lights on a school bus.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "23",
    "text": "If you see pedestrians at the side of the road and wanting to jaywalk you should",
    "answers": {
      "answer": "slow down and be ready to stop",
      "distractor_1": "maintain your speed as you have the right of way",
      "distractor_2": "always stop and yield the right of way",
      "distractor_3": "slow down and wave them across"
    },
    "chapter": "Chapter 6: Sharing the Road; Pedestrians",
    "source": "You must always be prepared to stop if you see a pedestrian who is about to step out in front of you. However, don't encourage jaywalking.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "24",
    "text": "Pedestrians with a white cane should be treated with extra care because",
    "answers": {
      "answer": "they might be uncertain when crossing a street",
      "distractor_1": "they will walk across a street at any point",
      "distractor_2": "they do not have to follow the rules of the road",
      "distractor_3": "they will not hear your vehicle"
    },
    "chapter": "Chapter 6: Sharing the Road; Pedestrians",
    "source": "Often, a blind or partially blind person will raise their cane when uncertain of crossing the street safely. That is your signal to stop.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "25",
    "text": "Which car does NOT have an escape route if a problem occurs ahead?",
    "answers": {
      "answer": "Car A",
      "distractor_1": "Car B",
      "distractor_2": "Car C",
      "distractor_3": "Car D"
    },
    "chapter": "Chapter 5: See - Think - Do; Space Margins",
    "source": "Try to leave yourself an escape route when you are driving on a multi-lane highway. Then, if something happens in front, you can pull into another lane.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    },
    "image": {
      "@file": "images/opkt/q25.png"
    }
  },
  {
    "@id": "26",
    "text": "Car A",
    "answers": {
      "answer": "may not pass",
      "distractor_1": "may pass with caution",
      "distractor_2": "may pass on the right",
      "distractor_3": "may not turn left over the line"
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "Yellow lines divide traffic moving in opposite directions. A broken line and a solid line mean you may pass only when it is safe and the broken line is on your side.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q26.png"
    }
  },
  {
    "@id": "27",
    "text": "This sign means",
    "answers": {
      "answer": "road narrows ahead",
      "distractor_1": "divided highway ends ahead",
      "distractor_2": "lane ends ahead",
      "distractor_3": "narrow structure ahead"
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "Most warning signs are yellow and diamond-shaped. They warn of possible hazards ahead.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q27.png"
    }
  },
  {
    "@id": "28",
    "text": "Making eye contact with cyclists around your vehicle",
    "answers": {
      "answer": "is a good means of communication",
      "distractor_1": "may cause them to lose balance",
      "distractor_2": "may distract you",
      "distractor_3": "is not useful"
    },
    "chapter": "Chapter 6: Sharing the Road; Cyclists",
    "source": "A cyclist often relies on eye contact as a means of communication. Make eye contact if you can. She or he is probably trying to anticipate your next move.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "29",
    "text": "If you notice a driver who is steering side to side or stopping without reason, you should",
    "answers": {
      "answer": "give yourself extra space",
      "distractor_1": "follow them to their destination",
      "distractor_2": "honk at them",
      "distractor_3": "flash your lights and pass them"
    },
    "chapter": "Chapter 5: See - Think - Do; Hazard Perception",
    "source": "To avoid surprises, think well ahead and ask yourself what could possibly happen in the driving environment.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "30",
    "text": "Stopped public transit buses",
    "answers": {
      "answer": "may hide pedestrians who are preparing to cross",
      "distractor_1": "require you to stop behind them",
      "distractor_2": "can't see vehicles that will pass them",
      "distractor_3": "have to honk before pulling into traffic"
    },
    "chapter": "Chapter 6: Sharing the Road; Public Transit Buses",
    "source": "Watch for buses that have stopped -- they may block your view of pedestrians about to cross the street, or they may be about to pull into traffic.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "31",
    "text": "When pulling out of a driveway on to a street with a sidewalk, what must the driver of Car A do before entering the street?",
    "answers": {
      "answer": "stop before the sidewalk",
      "distractor_1": "be prepared to stop, but continue into the street if no hazard is identified.",
      "distractor_2": "slow down and proceed with caution",
      "distractor_3": "stop just past the sidewalk before entering the street"
    },
    "chapter": "Chapter 4: Rules of the Road; Right-of-Way at Intersections",
    "source": "When you are pulling out of a driveway, alley or parking lot onto a road, stop before the sidewalk or area where pedestrians may be walking.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    },
    "image": {
      "@file": "images/opkt/q31.png"
    }
  },
  {
    "@id": "32",
    "text": "Your space margins are the distance between",
    "answers": {
      "answer": "your vehicle and other road users",
      "distractor_1": "your vehicle and the vehicle ahead of you",
      "distractor_2": "your vehicle and the vehicle behind you",
      "distractor_3": "your vehicle and the curb"
    },
    "chapter": "Chapter 5: See - Think - Do; Space Margins",
    "source": "You must have room to move if you need it. Space margins include your space in front, behind, beside and your lane position.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "33",
    "text": "One danger of driving too close to the car in front of you is",
    "answers": {
      "answer": "you may not be able to see what is up ahead",
      "distractor_1": "you will block the rear view mirror of the car in front",
      "distractor_2": "you will force the car in front to speed up",
      "distractor_3": "you will be in the blind spot of the car in front"
    },
    "chapter": "Chapter 5: See - Think - Do; Space Margins",
    "source": "Tailgating (following too closely behind the vehicle in front) is a major cause of crashes. If you tailgate, the vehicle in front can block your view of hazards ahead.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "34",
    "text": "Drivers should give cyclists extra room because they",
    "answers": {
      "answer": "might swerve or change lanes",
      "distractor_1": "often stop suddenly",
      "distractor_2": "often ride two abreast",
      "distractor_3": "do not have to follow the same rules of the road"
    },
    "chapter": "Chapter 6: Sharing the Road; Cyclists",
    "source": "Allow side margins - a significant number of crashes involving cyclists result from side-swiping. Make sure there is enough space if you want to pass a cyclist.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "35",
    "text": "This car may",
    "answers": {
      "answer": "not pass but can turn left over the line",
      "distractor_1": "pass but can't turn left over the line",
      "distractor_2": "not pass or turn left over the line",
      "distractor_3": "pass and turn left over the line"
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "Yellow lines divide traffic moving in opposite directions. A broken line and a solid line mean you may pass only when it is safe and the broken line is on your side.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q26.png"
    }
  },
  {
    "@id": "36",
    "text": "You should never sneak behind a truck when it is backing up because",
    "answers": {
      "answer": "it is dangerous if you enter one of its blind spots",
      "distractor_1": "they have a less effective braking system than cars",
      "distractor_2": "they carry more weight than your vehicle",
      "distractor_3": "the truck may create too much turbulence"
    },
    "chapter": "Chapter 6: Sharing the Road; Large Vehicles",
    "source": "Never try to sneak behind a truck if it is backing into a loading bay or out of a driveway because you will enter one of the truck driver's blind spots and risk being hit.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "37",
    "text": "You are driving along a multi-lane one way street. You see an emergency vehicle with lights flashing in your rear view mirror.  You should",
    "answers": {
      "answer": "move safely to either side of the road and stop",
      "distractor_1": "be ready to get out of the way",
      "distractor_2": "slow down and move to either side of the road",
      "distractor_3": "stop immediately"
    },
    "chapter": "Chapter 6: Sharing the Road; Emergency Vehicles",
    "source": "Usually the best thing to do is pull over to the right and stop (or to the left if you're driving in the left lane of a divided highway or on a one-way street).",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "38",
    "text": "The traffic light for Car A has just turned green.  An ambulance with flashing lights is coming up from behind.  What should Car A do?",
    "answers": {
      "answer": "Turn right to clear a path for the ambulance.",
      "distractor_1": "Back up and pull over to the curb.",
      "distractor_2": "Honk at Car C to pull over to the curb.",
      "distractor_3": "Speed up through the intersection"
    },
    "chapter": "Chapter 6: Sharing the Road; Emergency Vehicles",
    "source": "If you are stopped at an intersection and you are blocking the path of the emergency vehicle, you may have to turn the corner to get out of the way.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    },
    "image": {
      "@file": "images/opkt/q38.png"
    }
  },
  {
    "@id": "39",
    "text": "You are driving in the LEFT lane of a DIVIDED highway.  You see an emergency vehicle with lights flashing in your rear view mirror.  You should",
    "answers": {
      "answer": "move safely to the nearest edge of the road and stop",
      "distractor_1": "slow down and move to either side of the road",
      "distractor_2": "stop immediately",
      "distractor_3": "be ready to get out of the way"
    },
    "chapter": "Chapter 6: Sharing the Road; Emergency Vehicles",
    "source": "Usually the best thing to do is pull over to the right and stop (or to the left if you are driving in the left lane of a divided highway or on a one-way street).",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "40",
    "text": "To make a left turn at this intersection, Vehicle A should",
    "answers": {
      "answer": "move to the left lane before turning",
      "distractor_1": "turn from the centre lane",
      "distractor_2": "turn from any lane",
      "distractor_3": "move to the right lane before turning"
    },
    "chapter": "Chapter 4: Rules of the Road; Using Lanes Correctly",
    "source": "Before you make a turn, you need to get your vehicle into the correct lane. Then you need to end up in the correct lane when you complete your turn.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    },
    "image": {
      "@file": "images/opkt/q40.png"
    }
  },
  {
    "@id": "41",
    "text": "After you have stopped at a steady red light, you may",
    "answers": {
      "answer": "turn right or turn left into a one-way street if it is safe and no signs prohibit it",
      "distractor_1": "drive straight through",
      "distractor_2": "turn left or right",
      "distractor_3": "turn right only"
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "Watch for signs prohibiting you from making these turns on a red light.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    }
  },
  {
    "@id": "42",
    "text": "What should you be prepared to do when being passed on a two lane road?",
    "answers": {
      "answer": "slow down and make room so that they may safely pass",
      "distractor_1": "speed up to prevent them passing",
      "distractor_2": "maintain your speed at all times",
      "distractor_3": "maintain your speed while driving on the shoulder of the road"
    },
    "chapter": "Chapter 4: Rules of the Road; Passing",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    }
  },
  {
    "@id": "43",
    "text": "What should the driver of Car A do?",
    "answers": {
      "answer": "Slow down and stop.",
      "distractor_1": "Speed up to get through the crosswalk before the pedestrians step off the curb.",
      "distractor_2": "Honk to warn the pedestrian.",
      "distractor_3": "Slow down in case the pedestrians step into the crosswalk."
    },
    "chapter": "Chapter 6: Sharing the Road; Pedestrians",
    "source": "You must yield to pedestrians in marked crosswalks, if the pedestrian is close to your half of the road.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    },
    "image": {
      "@file": "images/opkt/q43.png"
    }
  },
  {
    "@id": "44",
    "text": "In this traffic circle, the driver of Vehicle A wants to head down Street B.  The correct path is",
    "answers": {
      "answer": "to yield to traffic in the circle, turn right when safe, and exit right down Path B",
      "distractor_1": "to turn left as soon as Motorcycle C passes by",
      "distractor_2": "complete one full revolution of the traffic circle before exiting",
      "distractor_3": "to wait until the traffic circle is empty, then turn left"
    },
    "chapter": "Chapter 4: Rules of the Road; Right-of-Way at Intersections",
    "source": "All vehicles must turn right to enter a traffic circle and right again to leave it.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    },
    "image": {
      "@file": "images/opkt/q44.png"
    }
  },
  {
    "@id": "45",
    "text": "Car A and Car B arrived at the stop sign at the same time.  Who should go first?",
    "answers": {
      "answer": "Car B.",
      "distractor_1": "Car A.",
      "distractor_2": "Both may move at the same time.",
      "distractor_3": "Both should wait for Car C to reach the intersection."
    },
    "chapter": "Chapter 4: Rules of the Road; Right-of-Way at Intersections",
    "source": "If two vehicles arrive at a four-way stop at the same time, the one on the right should go first.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    },
    "image": {
      "@file": "images/opkt/q45.png"
    }
  },
  {
    "@id": "46",
    "text": "Car B arrived at the stop sign first.  Who should go first?",
    "answers": {
      "answer": "Car B.",
      "distractor_1": "Car A.",
      "distractor_2": "Car B should wave Car A through.",
      "distractor_3": "Both may go at the same time"
    },
    "chapter": "Chapter 4: Rules of the Road; Right-of-Way at Intersections",
    "source": "The first vehicle to arrive at the intersection of a four-way stop and come to a complete stop should go first.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    },
    "image": {
      "@file": "images/opkt/q46.png"
    }
  },
  {
    "@id": "47",
    "text": "You are the driver of Car A  and want to make a right turn.  Which is the best See-Think-Do manoeuvre?",
    "answers": {
      "answer": "I see cyclist B approaching; I think, \"The cyclist may be at the corner when I want to turn.\"; I slow down.",
      "distractor_1": "I see the corner ahead; I think \"I'm going to be late for a meeting.\"; I accelerate and turn.",
      "distractor_2": "I see cyclist B; I think, \"I can get to the corner first.\"; accelerate and turn.",
      "distractor_3": "I see cyclist B; I think, \"I have the right of way.\"; I honk, and make the turn."
    },
    "chapter": "Chapter 6: Sharing the Road; Cyclists",
    "source": "Yield to cyclists as you would to any other vehicle. If you have the right-of-way at an intersection, proceed if it is safe.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    },
    "image": {
      "@file": "images/opkt/q47.png"
    }
  },
  {
    "@id": "48",
    "text": "The traffic signal has just turned yellow.  There are no other vehicles around.  Vehicle A should",
    "answers": {
      "answer": "slow down and stop since it is safe to do so",
      "distractor_1": "speed up and make it through before it turns red",
      "distractor_2": "scan the intersection, maintain speed, and go straight through",
      "distractor_3": "stop, and then proceed through the red light since there is no other traffic"
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "Yellow means that the signal is about the turn red. You must stop before entering the intersection unless you cannot safely stop in time.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q48.png"
    }
  },
  {
    "@id": "49",
    "text": "Hand signals",
    "answers": {
      "answer": "should be used if turn signals are hard to see",
      "distractor_1": "should always be used in good weather",
      "distractor_2": "are only used by cyclists and motorcycle riders",
      "distractor_3": "will only confuse others and should not be used"
    },
    "chapter": "Chapter 5: See - Think - Do; Communication",
    "source": "There are times when an automatic turn signal is hard to see in these situations, use a hand signal in addition to the turn signal.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "50",
    "text": "Before making a left turn, a driver should",
    "answers": {
      "answer": "yield to oncoming traffic and wait for a safe gap",
      "distractor_1": "signal any drivers behind to pass",
      "distractor_2": "make sure there are no cars behind",
      "distractor_3": "wait for oncoming drivers to wave you through"
    },
    "chapter": "Chapter 4: Rules of the Road; Right-of-Way at Intersections",
    "source": "When making a left turn on a green light, you must yield to oncoming traffic and wait for a safe gap before you turn.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    }
  },
  {
    "@id": "51",
    "text": "When you see a solid white line on your left it means",
    "answers": {
      "answer": "you may not changes lanes",
      "distractor_1": "it is separating traffic going in different directions.",
      "distractor_2": "you may pass with caution.",
      "distractor_3": "only public transit vehicles may pass."
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "White lines are used to separate lanes of traffic moving in the same direction. A solid line means do not change lanes.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    }
  },
  {
    "@id": "52",
    "text": "The driver of Car A should",
    "answers": {
      "answer": "enter freeway at the speed of  traffic flow",
      "distractor_1": "move into the far left lane as soon as possible",
      "distractor_2": "drive faster than traffic flow to better maneuver",
      "distractor_3": "slow down before entering the freeway"
    },
    "chapter": "Chapter 4: Rules of the Road; Highway or Freeway Entrances and Exits",
    "source": "A highway entrance gives you a short distance to match your speed to the vehicles already on the highway.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    },
    "image": {
      "@file": "images/opkt/q52.png"
    }
  },
  {
    "@id": "53",
    "text": "In the ACCELERATION lane before merging on to a highway, a driver should",
    "answers": {
      "answer": "speed up to match the speed of traffic.",
      "distractor_1": "signal and pull into the flow of traffic.",
      "distractor_2": "only be looking straight ahead.",
      "distractor_3": "be looking in the rear view mirror."
    },
    "chapter": "Chapter 4: Rules of the Road; Highway or Freeway Entrances and Exits",
    "source": "The acceleration lane is divided from the rest of the roadway by a solid white line. Use this lane to match your speed to the speed of the traffic on the freeway.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    }
  },
  {
    "@id": "54",
    "text": "When exiting a highway you should slow down",
    "answers": {
      "answer": "after you are in the exit lane.",
      "distractor_1": "before you are in the exit lane.",
      "distractor_2": "before you signal your intention to turn off the highway.",
      "distractor_3": "only if there are vehicles behind you."
    },
    "chapter": "Chapter 4: Rules of the Road",
    "source": "Signal your intention to turn off the highway, maintaining your speed until you enter the exit lane. Then slow down gradually as you prepare to enter roads with lower speed limits.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    }
  },
  {
    "@id": "55",
    "text": "This sign tells you",
    "answers": {
      "answer": "the fastest you may drive under ideal conditions",
      "distractor_1": "that there is a faster speed limit ahead",
      "distractor_2": "the ideal speed for this road in any conditions",
      "distractor_3": "the maximum speed unless you are passing"
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "Regulatory signs tell you about driving laws and regulations. It is an offence under the B.C. Motor Vehicle Act to disregard them.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q55.png"
    }
  },
  {
    "@id": "56",
    "text": "This sign means:",
    "answers": {
      "answer": "do not pass",
      "distractor_1": "there is only single lane traffic ahead",
      "distractor_2": "the road is for one way traffic only",
      "distractor_3": "there is a divided road ahead"
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "Regulatory signs tell you about driving laws and regulations. It is an offence under the B.C. Motor Vehicle Act to disregard them.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q56.png"
    }
  },
  {
    "@id": "57",
    "text": "This sign warns,",
    "answers": {
      "answer": "a school bus stop is ahead",
      "distractor_1": "an oncoming vehicle's lights will be flashing",
      "distractor_2": "a vehicle with its hazard lights flashing is ahead",
      "distractor_3": "a fire truck zone is ahead"
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "Most warning signs are yellow and diamond-shaped. They warn of possible hazards ahead.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q57.png"
    }
  },
  {
    "@id": "58",
    "text": "This sign means that in this lane, you must",
    "answers": {
      "answer": "turn left only",
      "distractor_1": "turn left or go straight ahead",
      "distractor_2": "turn right only",
      "distractor_3": "not turn left"
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "Lane use signs are signs showing which lanes may be used to turn or go straight and are mounted above the lane or at the side of the lane before the intersection.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q58.png"
    }
  },
  {
    "@id": "59",
    "text": "This sign, without a speed tab below, means",
    "answers": {
      "answer": "school zone - reduce speed when children are present",
      "distractor_1": "pedestrian crossing ahead",
      "distractor_2": "school crossing ahead",
      "distractor_3": "you must be prepared to stop at crosswalks controlled by crossing guards"
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings; School, Playground and Crosswalk Signs",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q59.png"
    }
  },
  {
    "@id": "60",
    "text": "Although environmental elements such as rain or ice contribute to skidding, the main cause of skidding is",
    "answers": {
      "answer": "poor driving skills",
      "distractor_1": "the mechanical condition of the car",
      "distractor_2": "tire blowouts",
      "distractor_3": "slippery roads"
    },
    "chapter": "Chapter 8: Emergency Strategies; Skid Control",
    "source": "Environmental elements like rain and ice contribute to skidding, but poor driving skills are the main cause of skidding. The way to avoid skids is to use your see-think-do skills.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers8.pdf"
    }
  },
  {
    "@id": "61",
    "text": "This sign means",
    "answers": {
      "answer": "only buses and high occupancy vehicles in this lane",
      "distractor_1": "only buses in this lane",
      "distractor_2": "area for buses and taxis only",
      "distractor_3": "public transit lane only"
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "A white diamond painted on the road surface marks reserved lanes. Reserved lane signs are also placed over or beside lanes that are reserved for certain vehicles.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q61.png"
    }
  },
  {
    "@id": "62",
    "text": "This sign means",
    "answers": {
      "answer": "stop sign ahead",
      "distractor_1": "proceed from this stop sign",
      "distractor_2": "be ready to stop ahead if necessary",
      "distractor_3": "no turns ahead after stopping"
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "Most warning signs are yellow and diamond-shaped. They warn of possible hazards ahead.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q62.png"
    }
  },
  {
    "@id": "63",
    "text": "What is the correct response if your car starts to skid?",
    "answers": {
      "answer": "ease off the accelerator and steer in the direction you want to go.",
      "distractor_1": "steer away from the direction of the skid.",
      "distractor_2": "brake hard to stop the vehicle as soon as possible,",
      "distractor_3": "shift into neutral and do not turn the steering wheel until skidding has stopped."
    },
    "chapter": "Chapter 8: Emergency Strategies; Skid Control",
    "source": "You should be able to avoid skidding by making safe choices in the first place. In slippery conditions, slow down.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers8.pdf"
    }
  },
  {
    "@id": "64",
    "text": "This sign warns",
    "answers": {
      "answer": "two-way traffic ahead",
      "distractor_1": "divided highway ahead",
      "distractor_2": "passing is prohibited ahead",
      "distractor_3": "passing is allowed ahead"
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "Most warning signs are yellow and diamond-shaped. They warn of possible hazards ahead.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q64.png"
    }
  },
  {
    "@id": "65",
    "text": "This sign means",
    "answers": {
      "answer": "railway crossing ahead - be prepared to stop",
      "distractor_1": "there are no warning lights",
      "distractor_2": "you may drive straight across the railway crossing",
      "distractor_3": "the railway crossing is no longer in use"
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "Public railway and highway crossings are indicated with signs or pavement markings and may also have mechanical or electrical warning devices for your protection.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q65.png"
    }
  },
  {
    "@id": "66",
    "text": "This sign means:",
    "answers": {
      "answer": "cyclists may be on roadway",
      "distractor_1": "bicycle lane ahead",
      "distractor_2": "bicycles prohibited",
      "distractor_3": "do not pass cyclists"
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "Most warning signs are yellow and diamond-shaped. They warn of possible hazards ahead.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q66.png"
    }
  },
  {
    "@id": "67",
    "text": "This sign means",
    "answers": {
      "answer": "steep hill ahead - slow or gear down",
      "distractor_1": "runaway vehicle lane ahead",
      "distractor_2": "truck stop ahead",
      "distractor_3": "truck route ahead"
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "Most warning signs are yellow and diamond-shaped. They warn of possible hazards ahead.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q67.png"
    }
  },
  {
    "@id": "68",
    "text": "This sign means",
    "answers": {
      "answer": "Bump or rough road ahead; slow down.",
      "distractor_1": "Industrial area ahead.",
      "distractor_2": "Steep hills ahead.",
      "distractor_3": "Danger; road ends ahead."
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "Most warning signs are yellow and diamond-shaped. They warn of possible hazards ahead.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q68.png"
    }
  },
  {
    "@id": "69",
    "text": "This sign means",
    "answers": {
      "answer": "obstruction - keep right or left",
      "distractor_1": "road narrows ahead",
      "distractor_2": "crosswalk ahead",
      "distractor_3": "straight through only"
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "Most warning signs are yellow and diamond-shaped. They warn of possible hazards ahead.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q69.png"
    }
  },
  {
    "@id": "70",
    "text": "This sign means",
    "answers": {
      "answer": "obstruction - keep left",
      "distractor_1": "obstruction ahead, keep right",
      "distractor_2": "do not enter",
      "distractor_3": "danger; road ends ahead"
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "Most warning signs are yellow and diamond-shaped. They warn of possible hazards ahead.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q70.png"
    }
  },
  {
    "@id": "71",
    "text": "This sign means",
    "answers": {
      "answer": "only buses may go on this signal",
      "distractor_1": "public transit buses may not proceed",
      "distractor_2": "all traffic must stop, emergency vehicles approaching",
      "distractor_3": "yield to public transit buses, then proceed"
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "Traffic lights are used to help organize the flow of traffic. The transit priority signal -- steady white rectangular light -- means only buses may go on this signal.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q71.png"
    }
  },
  {
    "@id": "72",
    "text": "This signal over a lane means",
    "answers": {
      "answer": "move out of this lane and into the lane with the green arrow",
      "distractor_1": "do not drive in this lane",
      "distractor_2": "this lane is under construction",
      "distractor_3": "this lane is about to open"
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "Lane control signals are placed over lanes to indicate which ones are open for driving.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q72.png"
    }
  },
  {
    "@id": "73",
    "text": "This sign means:",
    "answers": {
      "answer": "school crosswalk, yield to pedestrians;  if there is a crossing guard follow directions",
      "distractor_1": "pedestrian crosswalk",
      "distractor_2": "school zone - reduce speed",
      "distractor_3": "playground area"
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "School, playground and crosswalk signs tell you the rules to follow in areas where you need to be extra cautious.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q73.png"
    }
  },
  {
    "@id": "74",
    "text": "If you get angry or upset before driving, you should",
    "answers": {
      "answer": "calm down before you drive",
      "distractor_1": "not think about what made you angry as you drive",
      "distractor_2": "breathe deeply as you drive to regain your self-control",
      "distractor_3": "concentrate and be cautious as you drive"
    },
    "chapter": "Chapter 7: Personal Strategies; Dangerous Emotions",
    "source": "Controlling emotions: take a couple of moments to calm yourself down and leave your problems behind before you start to drive.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers7.pdf"
    }
  },
  {
    "@id": "75",
    "text": "A common cause of driver anger and frustration is",
    "answers": {
      "answer": "being impatient with the driving environment",
      "distractor_1": "other people's poor driving",
      "distractor_2": "an under-powered car",
      "distractor_3": "poor conditions of the road"
    },
    "chapter": "Chapter 7: Personal Strategies; Dangerous Emotions",
    "source": "Crowded traffic conditions and high-speed freeway driving often cause stress. Being slowed down by other traffic when you're in a hurry produces tension.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers7.pdf"
    }
  },
  {
    "@id": "76",
    "text": "Which of the following is NOT a good way to identify your driving attitude?",
    "answers": {
      "answer": "Blaming all driving errors on others.",
      "distractor_1": "Asking someone you trust to give you some feedback on your driving.",
      "distractor_2": "If you have a close call, asking yourself why it happened.",
      "distractor_3": "Asking if the poor driving you observe is your own."
    },
    "chapter": "Chapter 7: Personal Strategies; Taking Risks",
    "source": "Do you find yourself always blaming others for bad driving? If so, then ask yourself: \"Is it really their fault or could it be me?\"",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers7.pdf"
    }
  },
  {
    "@id": "77",
    "text": "Which of the following is MOST likely to make other drivers aggressive?",
    "answers": {
      "answer": "Not pulling over when a line of traffic has formed behind you.",
      "distractor_1": "Giving the right of way",
      "distractor_2": "Taking only one parking spot.",
      "distractor_3": "Moving over for merging traffic."
    },
    "chapter": "Chapter 7: Personal Strategies; Preventing Aggression",
    "source": "Sharing the road means considering other drivers. What messages do your actions give to other drivers?",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers7.pdf"
    }
  },
  {
    "@id": "78",
    "text": "When other drivers honk horns or yell at you,",
    "answers": {
      "answer": "assess the situation and rely on your own knowledge of safe driving practices",
      "distractor_1": "you should drive more slowly",
      "distractor_2": "yell back",
      "distractor_3": "do what they want you to do"
    },
    "chapter": "Chapter 7: Personal Strategies; Preventing Aggression",
    "source": "If you use your road sense, allow plenty of space and give others the right-of-way, you can help prevent situations that cause aggression.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers7.pdf"
    }
  },
  {
    "@id": "79",
    "text": "If you don't know what other drivers are going to do,",
    "answers": {
      "answer": "yield the right of way to be safe",
      "distractor_1": "honk or yell at them",
      "distractor_2": "take your right of way quickly",
      "distractor_3": "flash your high beam headlights at them"
    },
    "chapter": "Chapter 7: Personal Strategies; Preventing Aggression",
    "source": "Sharing the road means considering other drivers. What messages do your actions give to other drivers?",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers7.pdf"
    }
  },
  {
    "@id": "80",
    "text": "If you feel sleepy while driving you should,",
    "answers": {
      "answer": "stop somewhere safe, lock your doors,  and nap",
      "distractor_1": "reduce speed and drive with care",
      "distractor_2": "turn up the radio and maintain speed",
      "distractor_3": "open the window and maintain speed"
    },
    "chapter": "Chapter 7: Personal Strategies; Staying Awake",
    "source": "Being tired is one of the leading causes of crashes. Fatigue affects all stages of the See-Think-Do strategy.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers7.pdf"
    }
  },
  {
    "@id": "81",
    "text": "What factor is involved in over 30% of crash fatalities yearly in British Columbia?",
    "answers": {
      "answer": "Alcohol.",
      "distractor_1": "Tiredness.",
      "distractor_2": "Not signalling.",
      "distractor_3": "Vehicle malfunction."
    },
    "chapter": "Chapter 7: Personal Strategies",
    "source": "In an average year in B.C., over 100 people are killed and several thousand injured in police-reported collisions where alcohol was involved.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers7.pdf"
    }
  },
  {
    "@id": "82",
    "text": "If you are going into a curve at high speed, why is taking your foot off the accelerator a good idea before the curve?",
    "answers": {
      "answer": "it is a good strategy to help slow you down without using your brakes in the curve.",
      "distractor_1": "you’ll always need to brake while in the curve",
      "distractor_2": "your foot should never be over the accelerator in a curve",
      "distractor_3": "you will need power to accelerate while in the curve."
    },
    "chapter": "Chapter 5: See - Think - Do; Speed Control",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "83",
    "text": "Inertia is",
    "answers": {
      "answer": "the tendency for moving objects to continue moving forward in a straight line",
      "distractor_1": "the force that pulls everything towards the earth",
      "distractor_2": "the point around which all of an object's weight is balanced",
      "distractor_3": "the weight of a vehicle"
    },
    "chapter": "Chapter 5: See - Think - Do; Speed Control",
    "source": "When you go around a curve, inertia tries to keep you going in a straight line. The faster you are going, the greater the force of inertia.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "84",
    "text": "If you go around a curve too quickly, inertia may cause your vehicle to",
    "answers": {
      "answer": "stay in a straight line and go off the road",
      "distractor_1": "go even faster",
      "distractor_2": "shake uncontrollably",
      "distractor_3": "lock its brakes"
    },
    "chapter": "Chapter 5: See - Think - Do; Speed Control",
    "source": "When you go around a curve, inertia tries to keep you going in a straight line. The faster you are going, the greater the force of inertia.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "85",
    "text": "Which of the following is NOT likely to contribute to a vehicle skidding?",
    "answers": {
      "answer": "Driving at a speed suitable to the road conditions",
      "distractor_1": "Going around a corner too fast.",
      "distractor_2": "Poor driving skills.",
      "distractor_3": "Sudden change of direction."
    },
    "chapter": "Chapter 8: Emergency Strategies; Skid Control",
    "source": "Skids happen when drivers slam on the brakes and steer at the same time, go around a corner too fast or accelerate suddenly.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers8.pdf"
    }
  },
  {
    "@id": "86",
    "text": "Anti-lock braking systems (ABS) are different from regular brakes.  Emergency braking with ABS involves",
    "answers": {
      "answer": "squeezing the brakes and holding them on, until you come to a complete stop",
      "distractor_1": "constantly pumping the brakes hard to stop",
      "distractor_2": "never fully stopping",
      "distractor_3": "switching between pumping the brakes hard, then gently"
    },
    "chapter": "Chapter 5: See - Think - Do; Emergency Braking",
    "source": "In an emergency situation, drivers using ABS should apply continuous, firm, hard pressure to the brake pedal until the vehicle stops.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "87",
    "text": "If a vehicle has a standard transmission, coasting down a hill with the clutch pushed \"IN\"",
    "answers": {
      "answer": "is unsafe and illegal",
      "distractor_1": "is a good alternative to using the brakes",
      "distractor_2": "is all right in good weather",
      "distractor_3": "gives you more vehicle control"
    },
    "chapter": "Chapter 5: See - Think - Do; Speed Control",
    "source": "It is illegal to coast downhill in neutral or with the clutch in. You need to be in gear to safely control your vehicle.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "88",
    "text": "The beginning of a rainfall may cause roads to be particularly slippery because",
    "answers": {
      "answer": "the water mixes with oil on the road",
      "distractor_1": "your tires become cold",
      "distractor_2": "the water cools the road down quickly",
      "distractor_3": "the water washes the road clean quickly"
    },
    "chapter": "Chapter 8: Emergency Strategies; Loss of Traction",
    "source": "Rain makes the road surface slippery, especially during the beginning of a rainfall. The rain mixes with the oil on the road to create a slippery, oily film.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers8.pdf"
    }
  },
  {
    "@id": "89",
    "text": "Hydroplaning occurs",
    "answers": {
      "answer": "when your tires float on a film of water and lose traction with the road",
      "distractor_1": "when the road is very uneven",
      "distractor_2": "only when you are travelling in deep water and the car is lifted",
      "distractor_3": "only when it is raining heavily"
    },
    "chapter": "Chapter 8: Emergency Strategies; Loss of Traction",
    "source": "In a hydroplaning situation the driver instantly loses control of steering and braking. It can happen in rain or standing water.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers8.pdf"
    }
  },
  {
    "@id": "90",
    "text": "Which of these is NOT a good strategy for night driving?",
    "answers": {
      "answer": "Staying closer to the car ahead so you can see their tail lights more clearly.",
      "distractor_1": "Adjusting your mirror for night driving.",
      "distractor_2": "Keeping the interior lights off except for the instrument panel.",
      "distractor_3": "Increasing your following distance."
    },
    "chapter": "Chapter 8: Emergency Strategies; Overdriving the Headlights",
    "source": "Strategies for night driving also include glancing to the right edge of the road to avoid glare from oncoming lights.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers8.pdf"
    }
  },
  {
    "@id": "91",
    "text": "When driving in bad weather, you should make your vehicle easier for others to see by",
    "answers": {
      "answer": "turning on the low beam headlights",
      "distractor_1": "turning on the parking lights",
      "distractor_2": "turning on emergency flashers",
      "distractor_3": "flashing high beam headlights"
    },
    "chapter": "Chapter 8: Emergency Strategies; Using the Headlights; Loss of Visibility",
    "source": "In bad weather, you may have to pull over and stop if necessary until the visibility improves.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers8.pdf"
    }
  },
  {
    "@id": "92",
    "text": "If your vehicle breaks down on a busy highway you should NOT",
    "answers": {
      "answer": "try to do roadside repairs on your vehicle",
      "distractor_1": "stay with your vehicle and raise the hood",
      "distractor_2": "set out flares or warning triangles",
      "distractor_3": "turn on hazard lights"
    },
    "chapter": "Chapter 8: Emergency Strategies; Engine Problems",
    "source": "If your engine ever fails, signal and steer to the edge of the road, turn on your hazard lights, stay with your vehicle, put an S.O.S. notice in your windshield.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers8.pdf"
    }
  },
  {
    "@id": "93",
    "text": "Letting up on the brake just before hitting a large animal that you can't avoid",
    "answers": {
      "answer": "lessens the chance of it going through the windshield",
      "distractor_1": "minimizes the damage to your car",
      "distractor_2": "damages the animal less",
      "distractor_3": "stops the car from skidding"
    },
    "chapter": "Chapter 8: Emergency Strategies; Animals on the Road",
    "source": "If the animal is large and you can't stop in time, brake firmly and steer to strike the animal at an angle. Let up on the brake pedal just before hitting the animal.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers8.pdf"
    }
  },
  {
    "@id": "94",
    "text": "You are in Car A and there is a large truck opposite you in the intersection that is also turning.  Where will it be hardest for you to see any hazards?",
    "answers": {
      "answer": "Behind and to the right of the truck",
      "distractor_1": "Behind you",
      "distractor_2": "In the lane you are about to enter",
      "distractor_3": "Beside you to the right"
    },
    "chapter": "Chapter 5: See - Think - Do",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    },
    "image": {
      "@file": "images/opkt/q94.png"
    }
  },
  {
    "@id": "95",
    "text": "Before you back up, you check your mirrors and do a 360-degree vision check to look for hazards.  While backing up,",
    "answers": {
      "answer": "Turn and look through the rear window.",
      "distractor_1": "Ensure that both of your hands are firmly placed on the steering wheel",
      "distractor_2": "turn on your hazard lights",
      "distractor_3": "focus on your rear view mirror"
    },
    "chapter": "Chapter 5: See - Think - Do; Observation",
    "source": "Be especially careful when you’re backing out of a driveway. It’s easy to miss seeing children, pets, pedestrians, cyclists and people in wheelchairs.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "96",
    "text": "To maintain proper road (lane) position and to steer your vehicle in smooth line, you should",
    "answers": {
      "answer": "look well ahead in the direction you want to go.",
      "distractor_1": "focus on the rear of the vehicle in front of you.",
      "distractor_2": "use your mirrors.",
      "distractor_3": "look at the car beside you and maintain the distance between you."
    },
    "chapter": "Chapter 5: See - Think - Do; Steering",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "97",
    "text": "If a line of vehicles has formed behind you and you are driving below the speed limit, why is it a good idea to (safely) pull over to let them pass?",
    "answers": {
      "answer": "Other drivers behind you may become frustrated and angry and decide to unsafely drive around you",
      "distractor_1": "It is the law",
      "distractor_2": "Because British Columbians are polite.",
      "distractor_3": "You should never be driving below the speed limit"
    },
    "chapter": "Chapter 7: Personal Strategies; Preventing Aggression",
    "source": "If you use your smart driving skills, allow plenty of space and give others the right-of-way, you can help prevent situations that cause aggression.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers7.pdf"
    }
  },
  {
    "@id": "98",
    "text": "In what driving conditions would you use the two second rule for establishing a safe following distance between your vehicle and the vehicle in front of you?",
    "answers": {
      "answer": "Ideal weather conditions and on lower speed roads such as in a city.",
      "distractor_1": "When on a highway.",
      "distractor_2": "In bad weather conditions.",
      "distractor_3": "When you are traveling behind a large vehicle."
    },
    "chapter": "Chapter 5: See - Think - Do; Space Margins",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "99",
    "text": "You are approaching an intersection with no signs or painted crosswalks.  Someone has just stepped off the curb at the intersection to cross the street.  You must,",
    "answers": {
      "answer": "Yield and be prepared to stop to let them safely cross.",
      "distractor_1": "Maintain speed through the intersection as pedestrians will yield to vehicles.",
      "distractor_2": "stop and wave the pedestrian across",
      "distractor_3": "always stop at an intersection regardless of whether there are pedestrians"
    },
    "chapter": "Chapter 6: Sharing the Road; Pedestrians",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "100",
    "text": "It is 6pm and there is a school patrol at a crosswalk holding up a stop sign.  You can see no children around.  What should you do?",
    "answers": {
      "answer": "Obey the school patrol and stop.",
      "distractor_1": "Slow down and drive slowly through the crosswalk.",
      "distractor_2": "it is not during school hours so the school patrol has no business making you stop. Continue through the crosswalk.",
      "distractor_3": "Slow down and if you see children, then you should stop."
    },
    "chapter": "Chapter 6: Sharing the Road; Pedestrians",
    "source": "Obey school patrols or crossing supervisors at all times.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    },
    "image": {
      "@file": "images/opkt/q100.png"
    }
  },
  {
    "@id": "101",
    "text": "If a pedestrian is crossing the street with a guide dog, a driver should",
    "answers": {
      "answer": "Give them extra room as they may be uncertain about where traffic is in relation to them.",
      "distractor_1": "Not treat them differently than any other pedestrian.",
      "distractor_2": "Give a short honk on the horn to let them know it’s alright to cross.",
      "distractor_3": "Drive closer to them as they are listening for the sounds of vehicles."
    },
    "chapter": "Chapter 6: Sharing the Road; Pedestrians",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "102",
    "text": "Cyclists may swerve to the left and right while on a road as they need to avoid hazards or deal with windy conditions.  What is a good practice when passing a cyclist?",
    "answers": {
      "answer": "Leave them as much space as possible.",
      "distractor_1": "honk your horn before passing them.",
      "distractor_2": "Always maintain your established lane position.",
      "distractor_3": "only pass cyclists if they are riding in a designated bicycle lane.  Otherwise, you are not permitted to pass cyclists."
    },
    "chapter": "Chapter 6: Sharing the Road; Cyclists",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    },
    "image": {
      "@file": "images/opkt/q102.png"
    }
  },
  {
    "@id": "103",
    "text": "What is this cyclist going to do?",
    "answers": {
      "answer": "turn left",
      "distractor_1": "stop or slow down",
      "distractor_2": "turn right",
      "distractor_3": "get off of their bike"
    },
    "chapter": "Chapter 5: See - Think - Do; Communication",
    "source": "This section has an illustration that shows how cyclists signal left turns, right turns, and stopping or slowing down.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    },
    "image": {
      "@file": "images/opkt/q103.png"
    }
  },
  {
    "@id": "104",
    "text": "How much space should you leave beside you while passing a cyclist?",
    "answers": {
      "answer": "Allow as much as is safely possible. One metre or more.",
      "distractor_1": "Allow up to a metre between you and the cyclist.",
      "distractor_2": "You should never pass a cyclist unless they are riding in a designated bicycle lane.",
      "distractor_3": "Do not adjust your position in the lane."
    },
    "chapter": "Chapter 6: Sharing the Road; Cyclists",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "105",
    "text": "A truck and trailer driving beside you on your right hand side is about to turn right.  What hazard should you watch out for most?",
    "answers": {
      "answer": "The truck may swing wide into your lane as it needs space to clear the curb. Slow down and be cautious.",
      "distractor_1": "There is no reason to be extra cautious.  It is the truck driver’s responsibility to make a safe turn.",
      "distractor_2": "Pedestrians walking in front of the truck that you can't see.",
      "distractor_3": "The back end of the truck may skid into your lane.  You should stop until the truck has turned."
    },
    "chapter": "Chapter 6: Sharing the Road; Large Vehicles",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    },
    "image": {
      "@file": "images/opkt/q105.png"
    }
  },
  {
    "@id": "106",
    "text": "You are stopped for a school bus that has its red lights flashing.  When may you proceed?",
    "answers": {
      "answer": "You must wait until the lights have stopped flashing. If the bus has a swing-out stop sign, it must also be pulled in.",
      "distractor_1": "You must wait for the bus to proceed first.",
      "distractor_2": "Check for children, then proceed if it appears to be safe.",
      "distractor_3": "When other vehicles start to move."
    },
    "chapter": "Chapter 6: Sharing the Road; School Buses",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    },
    "image": {
      "@file": "images/opkt/q106.png"
    }
  },
  {
    "@id": "107",
    "text": "When are you required to yield to a public transit bus that has a yield sign on the back and is signaling to enter traffic?",
    "answers": {
      "answer": "on all roads where the speed limit is 60km/h or lower",
      "distractor_1": "always yield to a public transit bus regardless of the posted speed limit.",
      "distractor_2": "on all roads where the speed limit is 30km/h or lower",
      "distractor_3": "only if there is no traffic behind you"
    },
    "chapter": "Chapter 6: Sharing the Road; Public Transit Buses",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    },
    "image": {
      "@file": "images/opkt/q107.png"
    }
  },
  {
    "@id": "108",
    "text": "Why is increasing the space margin between you and a car in front of your vehicle a good idea when being tailgated?",
    "answers": {
      "answer": "you can stop more gradually if the car in front suddenly brakes or a hazard appears, reducing the chance of the tailgater crashing into you.",
      "distractor_1": "you should actually decrease the space margin to encourage the person in front to speed up.",
      "distractor_2": "because it will allow the person behind you to more easily pass.",
      "distractor_3": "to let the tailgater know that they have to back away."
    },
    "chapter": "Chapter 5: See - Think - Do; Space Margins",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    },
    "image": {
      "@file": "images/opkt/q108.png"
    }
  },
  {
    "@id": "109",
    "text": "When following a fire truck, how far back must you be?",
    "answers": {
      "answer": "150 metres",
      "distractor_1": "160 metres",
      "distractor_2": "50 metres",
      "distractor_3": "60 metres"
    },
    "chapter": "Chapter 6: Sharing the Road; Emergency Vehicles",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "110",
    "text": "There are many collisions between cars and trains at night because",
    "answers": {
      "answer": "The side of a train already crossing the road can be difficult to see at night and the car driver does not see the train.",
      "distractor_1": "headlights were not turned on",
      "distractor_2": "of driver fatigue",
      "distractor_3": "of weather conditions"
    },
    "chapter": "Chapter 6: Sharing the Road; Trains",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    },
    "image": {
      "@file": "images/opkt/q110.png"
    }
  },
  {
    "@id": "111",
    "text": "What are the only colours of flashing lights you will find at a railroad crossing?",
    "answers": {
      "answer": "Red.",
      "distractor_1": "Red and green",
      "distractor_2": "Red yellow and green",
      "distractor_3": "Green and yellow"
    },
    "chapter": "Chapter 6: Sharing the Road; Trains",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "112",
    "text": "Do you have to stop at intersections with no lights or stop signs (i.e. an uncontrolled intersection)?",
    "answers": {
      "answer": "no, but you should slow down and be prepared to yield to other road users",
      "distractor_1": "yes, you must always stop at these intersections",
      "distractor_2": "no. always maintain your speed",
      "distractor_3": "no, but use your horn as approach the intersection."
    },
    "chapter": "Chapter 4: Rules of the Road Types of Intersections",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    },
    "image": {
      "@file": "images/opkt/q112.png"
    }
  },
  {
    "@id": "113",
    "text": "You see ahead of you that a traffic light has been green for a long time.  What should you do?",
    "answers": {
      "answer": "you should be ready for this stale green light to change.  Be prepared to stop if necessary.",
      "distractor_1": "look ahead to the intersection and if clear, speed up through the light.",
      "distractor_2": "begin braking as this stale green light will soon change.",
      "distractor_3": "you do not need to think about the light.  It is green."
    },
    "chapter": "Chapter 4: Rules of the Road Right-of-Way At Intersections",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    },
    "image": {
      "@file": "images/opkt/q113.png"
    }
  },
  {
    "@id": "114",
    "text": "You are stopped at a railway crossing where there are flashing lights and bells.  When are you allowed to proceed?",
    "answers": {
      "answer": "you must remain stopped until it is safe to cross",
      "distractor_1": "when the train has passed and the flashing lights turn yellow",
      "distractor_2": "when you see the green signal",
      "distractor_3": "when the train has passed"
    },
    "chapter": "Chapter 6: Sharing the Road; Trains",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "115",
    "text": "If you are driving slowly and a line of cars forms behind you should,",
    "answers": {
      "answer": "pull over and stop to let other drivers go by.",
      "distractor_1": "maintain your speed.",
      "distractor_2": "slow down and wave to cars to let them know they should pass.",
      "distractor_3": "move to the right and drive on the shoulder."
    },
    "chapter": "Chapter 7: Personal Strategies; Preventing Aggression",
    "source": "Sharing the road means considering other drivers. What messages do your actions give to other drivers?",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers7.pdf"
    }
  },
  {
    "@id": "116",
    "text": "In good weather in the city, your minimum following distance should be at LEAST",
    "answers": {
      "answer": "2 seconds",
      "distractor_1": "4 seconds",
      "distractor_2": "1 second",
      "distractor_3": "3 seconds"
    },
    "chapter": "Chapter 5: See - Think - Do; Space Margins",
    "source": "Always leave a safe following distance between your vehicle and the vehicle in front. You need at least two seconds of space in front in good weather and road conditions.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "117",
    "text": "If you are behind a vehicle on an unpaved road, your minimum following distance should be at LEAST",
    "answers": {
      "answer": "3 seconds",
      "distractor_1": "2 seconds",
      "distractor_2": "4 seconds",
      "distractor_3": "6 seconds"
    },
    "chapter": "Chapter 5: See - Think - Do; Space Margins",
    "source": "Allow at least three seconds following distance when you are following another vehicle on an unpaved road where dust or gravel may be in the air.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "118",
    "text": "What are these cyclists signaling to do?",
    "answers": {
      "answer": "Turn right.",
      "distractor_1": "They are about to get off their bikes.",
      "distractor_2": "Turn left.",
      "distractor_3": "Stop or slow down."
    },
    "chapter": "Chapter 5: See - Think - Do; Communication",
    "source": "This section has an illustration that shows how cyclists signal left turns, right turns, and stopping or slowing down.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    },
    "image": {
      "@file": "images/opkt/q118.png"
    }
  },
  {
    "@id": "119",
    "text": "This sign on a transit bus when it is signalling to enter traffic means",
    "answers": {
      "answer": "you must yield to them where the speed limit is 60 km/h or lower.",
      "distractor_1": "yield, regardless of the posted speed limit.",
      "distractor_2": "yield on all roads where the speed limit is 30 km/h or lower.",
      "distractor_3": "yield only if there is no traffic behind you."
    },
    "chapter": "Chapter 6: Sharing the Road; Public Transit Buses",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    },
    "image": {
      "@file": "images/opkt/q119.png"
    }
  },
  {
    "@id": "120",
    "text": "You are in busy traffic and someone is driving too closely behind you. Which of the following actions will help protect you?",
    "answers": {
      "answer": "Gradually increase the space between you and the vehicle in front of you.",
      "distractor_1": "Decrease the space in front of you to encourage the person in front to speed up.",
      "distractor_2": "Accelerate to leave more space behind.",
      "distractor_3": "Honk and flash your brake lights."
    },
    "chapter": "Chapter 5: See - Think - Do; Space Margins",
    "source": "It's a good idea to slow down slightly to increase your space in front. This way, if you have to stop, you can stop more gradually.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "121",
    "text": "When will you see green lights flashing at a railway crossing?",
    "answers": {
      "answer": "There are no flashing green lights at a railway crossing.",
      "distractor_1": "After the train has passed as a signal for you to go forward.",
      "distractor_2": "When there are no trains coming.",
      "distractor_3": "At night time to help you see the train signals better."
    },
    "chapter": "Chapter 6: Sharing the Road; Trains",
    "source": "Unlike traffic lights there are no green lights at a railway crossing. When the red railway lights go off and any barriers go up, you may cross the track if the train has passed and it is safe to proceed.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "122",
    "text": "Do you stop at an uncontrolled intersection?",
    "answers": {
      "answer": "You only need to slow down and look out for other road users.",
      "distractor_1": "You must always stop at uncontrolled intersections.",
      "distractor_2": "You would maintain speed but watch for other road users.",
      "distractor_3": "You would honk to let others know you are there."
    },
    "chapter": "Chapter 4: Rules of the Road; Types of Intersections",
    "source": "This is different from when you enter a road from a driveway, alley or parking lot in which case you should always stop before crossing a sidewalk. Make sure you study the rules for the different types of intersections. It’s one of the most common mistakes made when taking our tests.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    }
  },
  {
    "@id": "123",
    "text": "Before entering from a side street or alley must the driver of Car A stop before the sidewalk?",
    "answers": {
      "answer": "Yes, you must always stop before crossing a sidewalk out of an alleyway or side street.",
      "distractor_1": "If the intersection is clear you can just slow down and proceed.",
      "distractor_2": "You must stop before the edge of the road.",
      "distractor_3": "You only need to stop if there are pedestrians present."
    },
    "chapter": "Chapter 4: Rules of the Road; Types of Intersections",
    "source": "This is different from what you should do at an uncontrolled intersection, which is to slow down and look for other road users. Make sure you study the rules for the different types of intersections.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    },
    "image": {
      "@file": "images/opkt/q123.png"
    }
  },
  {
    "@id": "124",
    "text": "When the solid line of a double yellow line is on your side",
    "answers": {
      "answer": "you may not pass.",
      "distractor_1": "you may pass only when it’s safe.",
      "distractor_2": "you may not turn left over the line under any circumstances.",
      "distractor_3": "you may pass on the right."
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "You may not pass however you may make a left turn if you are not impeding other traffic. Yellow lines divide traffic moving in opposite directions. A broken line and a solid line mean you may pass only when it is safe and the broken line is on your side.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q124.png"
    }
  },
  {
    "@id": "125",
    "text": "When the solid line of a double yellow line is on your side, are you allowed to make a left turn?",
    "answers": {
      "answer": "Yes as long as you are not impeding other traffic.",
      "distractor_1": "You are not allowed to turn left.",
      "distractor_2": "Only drivers on the other side of the road may make a left turn.",
      "distractor_3": "Solid yellow lines only indicate rules for passing."
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "It can be confusing when there are two yellow lines in the middle of the street. Just remember if both yellow lines are solid then no passing is allowed in either direction. You may make a left turn as long as you are not impeding other traffic.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q125.png"
    }
  },
  {
    "@id": "126",
    "text": "A vehicle skidding is most likely caused by",
    "answers": {
      "answer": "poor driving skills.",
      "distractor_1": "other drivers stopping suddenly.",
      "distractor_2": "slippery conditions.",
      "distractor_3": "the mechanical condition of the car."
    },
    "chapter": "Chapter 8: Emergency Strategies; Skid Control",
    "source": "We purposely asked the question this way. Slippery conditions will make a car skid but you can choose to reduce speed or increase your following distance with other vehicles. Think about how you will drive if it is icy on the road. Do you have to drive?",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers8.pdf"
    }
  },
  {
    "@id": "127",
    "text": "If driving on a slippery road would you drive at the posted speed limit?",
    "answers": {
      "answer": "I can decide to choose a reduced speed that is safe or increase my following distance with other vehicles to avoid skidding.",
      "distractor_1": "Yes, as long as I don't go over the speed limit I should be able to avoid skidding.",
      "distractor_2": "Only if my vehicle’s tires were designed for all weather conditions.",
      "distractor_3": "Only if I have snow tires on my vehicle."
    },
    "chapter": "Chapter 8: Emergency Strategies",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers8.pdf"
    }
  },
  {
    "@id": "128",
    "text": "Which of the following is NOT something you should do while merging on to a highway?",
    "answers": {
      "answer": "Stop and wait for a gap.",
      "distractor_1": "Scan for a safe gap.",
      "distractor_2": "Adjust your speed if necessary using the acceleration lane.",
      "distractor_3": "Signal your intention."
    },
    "chapter": "Chapter 4: Rules of the Road; Highway or Freeway Entrances and Exits",
    "source": "Make sure you know how to enter and exit highways and freeways.  Don't stop unless you have no other choice.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    }
  },
  {
    "@id": "129",
    "text": "Unless otherwise posted, the speed limit OUTSIDE of cities and towns is",
    "answers": {
      "answer": "80 km/h",
      "distractor_1": "70 km/h",
      "distractor_2": "60 km/h",
      "distractor_3": "50 km/h"
    },
    "chapter": "Chapter 5: See - Think – Do; Appropriate Speeds",
    "source": "Unless a sign tells you otherwise, the speed limit is 80km/h outside of cities and towns.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "130",
    "text": "A driver should honk their horn at a cyclist",
    "answers": {
      "answer": "as a suitable warning.",
      "distractor_1": "to tell the cyclist to get out of the way.",
      "distractor_2": "to make the cyclist give you room.",
      "distractor_3": "to show that the driver knows that the cyclist is there."
    },
    "chapter": "Chapter 6: Sharing the Road; Cyclists",
    "source": "Don’t honk your horn at a cyclist unless you need to give a warning. A loud honk could startle a cyclist and even cause a fall.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "131",
    "text": "You are on a narrow road and want to pass a cyclist, you should",
    "answers": {
      "answer": "wait for a clear, straight stretch that will allow you to pull out and give the cyclist plenty of room as you pass.",
      "distractor_1": "pass the cyclist only if they are riding in a designated bicycle lane. Otherwise, you are not permitted to pass cyclists.",
      "distractor_2": "honk your horn to let them know you want to pass.",
      "distractor_3": "pass them as it is a cyclist’s responsibility to yield to vehicles."
    },
    "chapter": "Chapter 6: Sharing the Road; Cyclists",
    "source": "Cyclists are vulnerable to being hit while being passed. Wait for a clear, straight stretch that will allow you to pull out and give the cyclist plenty of room as you pass",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "132",
    "text": "In heavy traffic, how can you help a cyclist who may want to change lanes and turn left at an intersection?",
    "answers": {
      "answer": "Leave extra room so the cyclist can safely change lanes.",
      "distractor_1": "Honk at the cyclist and wave them across.",
      "distractor_2": "Maintain your lane position.",
      "distractor_3": "Move into another lane so that other drivers can see their hand signals."
    },
    "chapter": "Chapter 6: Sharing the Road; Cyclists",
    "source": "Honking your horn could startle them and using gestures can sometimes be misunderstood.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "133",
    "text": "A steady yellow light means:",
    "answers": {
      "answer": "stop unless it is unsafe to do so.",
      "distractor_1": "stop only if there are other vehicles in the intersection.",
      "distractor_2": "stop in all cases.",
      "distractor_3": "accelerate if you know you can make it through before it turns red."
    },
    "chapter": "Chapter 4: Rules of the Road; Right-of-Way at Intersections",
    "source": "Yellow means that the signal is about the turn red. You must stop before entering the intersection unless you cannot safely stop in time.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    },
    "image": {
      "@file": "images/opkt/q133.png"
    }
  },
  {
    "@id": "134",
    "text": "Vehicles at a four-way stop intersection must yield to the vehicle on their right UNLESS:",
    "answers": {
      "answer": "another vehicle comes to a complete stop before them.",
      "distractor_1": "another vehicle who got there first waves you on.",
      "distractor_2": "another vehicle is a bus.",
      "distractor_3": "pedestrians are walking in front of the other vehicles. So you can go first."
    },
    "chapter": "Chapter 4: Rules of the Road; Right-of-Way at Intersections",
    "source": "If someone does take the right of way from you by going first, yield to the other driver for safety.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    },
    "image": {
      "@file": "images/opkt/q134.png"
    }
  },
  {
    "@id": "135",
    "text": "If two vehicles arrive at a 4-way stop intersection at the same time and are facing each other",
    "answers": {
      "answer": "a vehicle that is going straight through may go first.",
      "distractor_1": "a vehicle that is turning may go first.",
      "distractor_2": "it is always ok if both vehicles move at the same time.",
      "distractor_3": "always wait for the other vehicle to move first."
    },
    "chapter": "Chapter 4: Rules of the Road; Right-of-Way at Intersections",
    "source": "If someone does take the right of way from you by going first, yield to the other driver for safety.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    },
    "image": {
      "@file": "images/opkt/q135.png"
    }
  },
  {
    "@id": "136",
    "text": "You have passed the acceleration area and are ready to merge. You should first:",
    "answers": {
      "answer": "look to your left and behind for a safe gap.",
      "distractor_1": "slow down.",
      "distractor_2": "keep speeding up.",
      "distractor_3": "use a hand signal to merge into traffic."
    },
    "chapter": "Chapter 4: Rules of the Road; Highway or Freeway Entrances and Exits",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    },
    "image": {
      "@file": "images/opkt/q52.png"
    }
  },
  {
    "@id": "137",
    "text": "Why is it important to come to a complete stop for a yellow light when possible?",
    "answers": {
      "answer": "All of these.",
      "distractor_1": "It is the law.",
      "distractor_2": "It is the safest thing to do.",
      "distractor_3": "To avoid a collision."
    },
    "chapter": "Chapter 4: Rules of the Road; Right-of-Way at Intersections",
    "source": "Think about opposing traffic turning left. If you go through the yellow light and they turn can you avoid a crash? It’s only a short wait at the light.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    }
  },
  {
    "@id": "138",
    "text": "One way in which a passenger can help the driver to drive safely is by",
    "answers": {
      "answer": "avoiding conversations that could distract the driver.",
      "distractor_1": "talking loudly so that the driver can hear the conversation.",
      "distractor_2": "turning up the radio.",
      "distractor_3": "asking questionsFull to keep the driver alert."
    },
    "chapter": "Chapter 7: Personal Strategies; Unsafe Passengers",
    "source": "When you are driving, your mind and senses should be focused only on driving. Distractions can affect your hazard perception and your reaction time.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers7.pdf"
    }
  },
  {
    "@id": "139",
    "text": "When other drivers act aggressively towards you, it’s best to",
    "answers": {
      "answer": "avoid eye contact and give the other driver plenty of room.",
      "distractor_1": "return the aggression, or they’ll think they can do what they want.",
      "distractor_2": "drive more slowly, but take your right of way.",
      "distractor_3": "try to pass them and leave them behind."
    },
    "chapter": "Chapter 7: Personal Strategies; Aggression on the road",
    "source": "If you use your smart driving skills, allow plenty of space and give others the right-of-way, you can help prevent situations that cause aggression.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers7.pdf"
    }
  },
  {
    "@id": "140",
    "text": "The vehicle on the right is at more risk of losing traction around a curve because",
    "answers": {
      "answer": "it has a higher centre of gravity than the vehicle on the left.",
      "distractor_1": "it has larger tires than the vehicle on the left.",
      "distractor_2": "it's actually at less risk because it has bigger brakes.",
      "distractor_3": "it's actually at less risk because the driver can see better."
    },
    "chapter": "Chapter 5: See - Think - Do; Speed Control",
    "source": "A vehicle with a higher centre of gravity is less stable on uneven road surfaces and is more likely to tip over on a curve taken at higher speeds.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    },
    "image": {
      "@file": "images/opkt/q140.png"
    }
  },
  {
    "@id": "141",
    "text": "You’re driving around a curve and you start to lose traction. What should you do?",
    "answers": {
      "answer": "Ease off the accelerator and re-apply gently when you regain traction.",
      "distractor_1": "Pump the brakes.",
      "distractor_2": "Speed up.",
      "distractor_3": "Apply the brakes firmly."
    },
    "chapter": "Chapter 5: See - Think - Do; Handling Curves",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "142",
    "text": "You’re driving with your high beam headlights on and a car is approaching. You must dim them when the approaching car is within",
    "answers": {
      "answer": "150 metres.",
      "distractor_1": "200 metres.",
      "distractor_2": "50 metres.",
      "distractor_3": "100 metres."
    },
    "chapter": "Chapter 8: Emergency Strategies; Using the Headlights",
    "source": "Do you have trouble judging distances? Most people do. Be courteous and dim your headlights as early as you can.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers8.pdf"
    }
  },
  {
    "@id": "143",
    "text": "Headlights must be used",
    "answers": {
      "answer": "from 30 minutes after sunset until 30 minutes before sunrise.",
      "distractor_1": "overnight.",
      "distractor_2": "during the day.",
      "distractor_3": "from dawn to dusk."
    },
    "chapter": "Chapter 8: Emergency Strategies; Using the Headlights",
    "source": "It's a safe practice to turn on your headlights whenever it seems dark such as in heavy rain or driving in dark valleys.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers8.pdf"
    }
  },
  {
    "@id": "144",
    "text": "Which of the following should you NOT do after being involved in a crash?",
    "answers": {
      "answer": "Discuss who is at fault for the crash.",
      "distractor_1": "Move the vehicles off the road if it is safe to do so.",
      "distractor_2": "Exchange driver’s licence numbers with any other drivers involved.",
      "distractor_3": "Draw a sketch or take photos of the scene, noting conditions such as time, location and weather."
    },
    "chapter": "Chapter 8: Emergency Strategies; At the Scene of a Crash",
    "source": "It will be up to your insurer to assess damages and law enforcement to assess any fines.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers8.pdf"
    }
  },
  {
    "@id": "145",
    "text": "The MINIMUM safe following distance of two seconds behind the car ahead of you is",
    "answers": {
      "answer": "for ideal conditions in the city.",
      "distractor_1": "always the rule.",
      "distractor_2": "for only bad weather conditions.",
      "distractor_3": "only on highways."
    },
    "chapter": "Chapter 5: See - Think - Do; Space Margins",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    }
  },
  {
    "@id": "146",
    "text": "At intersections with no lights or stop signs, you should",
    "answers": {
      "answer": "slow down, cover the brake pedal and look both ways as you near the intersection.",
      "distractor_1": "slow down and stop at the intersection.",
      "distractor_2": "maintain your speed and scan the intersection.",
      "distractor_3": "slow down as you enter the intersection."
    },
    "chapter": "Chapter 4: Rules of the Road; Types of Intersections",
    "source": "This is different from when you enter a road from a driveway, alley or parking lot in which case you should always stop before crossing a sidewalk. Make sure you study the rules for the different types of intersections. It’s one of the most common mistakes made when taking our tests.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    },
    "image": {
      "@file": "images/opkt/q112.png"
    }
  },
  {
    "@id": "147",
    "text": "What signal at an intersection would be treated the same as a stop sign?",
    "answers": {
      "answer": "A flashing red light.",
      "distractor_1": "A flashing yellow light.",
      "distractor_2": "A flashing green light.",
      "distractor_3": "A steady yellow light."
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": "If there is a power outage and no lights at all, you would also treat the intersection the same as a stop sign.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    }
  },
  {
    "@id": "148",
    "text": "Are you allowed to use hands-free 'voice to text' features on your phone while operating a vehicle if you have your learner's (L) or novice (N) licence?",
    "answers": {
      "answer": "You are not allowed to operate hands-free electronic devices at any time while driving.",
      "distractor_1": "Only during daylight hours.",
      "distractor_2": "Only if the device requires one touch to activate or deactivate.",
      "distractor_3": "Only when a qualified supervisor is driving with you."
    },
    "chapter": "Chapter 7: Personal Strategies; Keeping Focused",
    "source": "This includes pre-programmed or voice-activated GPS devices.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers7.pdf"
    }
  },
  {
    "@id": "149",
    "text": "While operating a vehicle, if you have your learner’s (L) or novice licence (N) are you allowed to use hands free ‘voice to text’ on your phone while driving?",
    "answers": {
      "answer": "You are not allowed to operate hands-free electronic devices at any time while driving.",
      "distractor_1": "Only during daylight hours.",
      "distractor_2": "Only if the device requires one touch to activate or deactivate the voice command.",
      "distractor_3": "Only when a qualified supervisor is driving with you."
    },
    "chapter": "Chapter 7: Personal Strategies; Keeping Focused",
    "source": "This includes pre-programmed or voice-activated GPS devices.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers7.pdf"
    }
  },
  {
    "@id": "150",
    "text": "When approaching stopped emergency vehicles displaying flashing lights you must",
    "answers": {
      "answer": "slow down and change lanes if traffic permits.",
      "distractor_1": "be ready to get out of the way.",
      "distractor_2": "move to either side of the road and stop.",
      "distractor_3": "stop immediately."
    },
    "chapter": "Chapter 6: Sharing the Road; Emergency Workers on Roads",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "151",
    "text": "When approaching a stopped emergency vehicle with flashing lights on highways with speed limits of 80 km/h or over, in addition to changing lanes, you must slow to",
    "answers": {
      "answer": "70 km/h.",
      "distractor_1": "40 km/h.",
      "distractor_2": "50 km/h.",
      "distractor_3": "30 km/h."
    },
    "chapter": "Chapter 6: Sharing the Road; Emergency Workers on Roads",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "152",
    "text": "When approaching a stopped emergency vehicle with flashing lights on highways with speed limits of under 80 km/h, in addition to changing lanes, you must slow to",
    "answers": {
      "answer": "40 km/h.",
      "distractor_1": "70 km/h.",
      "distractor_2": "60 km/h.",
      "distractor_3": "50 km/h."
    },
    "chapter": "Chapter 6: Sharing the Road; Emergency Workers on Roads",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers6.pdf"
    }
  },
  {
    "@id": "153",
    "text": "Space margins include being able to quickly move into another lane to avoid hazards.  Which vehicle does NOT have a space margin to change lanes?",
    "answers": {
      "answer": "Car B",
      "distractor_1": "Car C",
      "distractor_2": "Car A",
      "distractor_3": "Car D"
    },
    "chapter": "Chapter 5: See - Think - Do; Space Margins",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers5.pdf"
    },
    "image": {
      "@file": "images/opkt/q153.png"
    }
  },
  {
    "@id": "154",
    "text": "This sign means:",
    "answers": {
      "answer": "Two-way left turn lane.",
      "distractor_1": "Left turns only at this intersection.",
      "distractor_2": "Two-way traffic ahead.",
      "distractor_3": "Left and right turns allowed at this intersection."
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q154.png"
    }
  },
  {
    "@id": "155",
    "text": "This sign means:",
    "answers": {
      "answer": "No turns permitted at this intersection.",
      "distractor_1": "No lane changes allowed.",
      "distractor_2": "One-way traffic only.",
      "distractor_3": "Yield to traffic in intersection."
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q155.png"
    }
  },
  {
    "@id": "156",
    "text": "This sign means slow to 30 km/h:",
    "answers": {
      "answer": "Every day from dawn to dusk.",
      "distractor_1": "When you see children on road.",
      "distractor_2": "Weekdays from dawn to dusk.",
      "distractor_3": "Weekends from dawn to dusk."
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q156.png"
    }
  },
  {
    "@id": "157",
    "text": "This sign means:",
    "answers": {
      "answer": "Playground nearby - drive with caution.",
      "distractor_1": "Slow to 30 km/h if pedestrians crossing.",
      "distractor_2": "Sports stadium nearby - watch for hazards.",
      "distractor_3": "School crosswalk - stop for pedestrians."
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q157.png"
    }
  },
  {
    "@id": "158",
    "text": "A steady green arrow means:",
    "answers": {
      "answer": "You may turn in the direction of the arrow if the intersection is clear.",
      "distractor_1": "The cross-street is a one way street in the direction of the arrow.",
      "distractor_2": "You may turn in the direction of the arrow after coming to a complete stop.",
      "distractor_3": "You may only turn left at this intersection."
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q158.png"
    }
  },
  {
    "@id": "159",
    "text": "A steady red light means:",
    "answers": {
      "answer": "Stop. After coming to a full stop you may turn right or turn left onto a one-way street unless a sign forbids it.",
      "distractor_1": "Stop if traffic is approaching.",
      "distractor_2": "You must stop unless you are turning right.",
      "distractor_3": "Stop, then proceed when safe."
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q159.png"
    }
  },
  {
    "@id": "160",
    "text": "A flashing red light means:",
    "answers": {
      "answer": "Stop and proceed when it is safe to do so.",
      "distractor_1": "Stop until the light changes to a flashing green light.",
      "distractor_2": "Slow down and proceed through intersection if safe.",
      "distractor_3": "Stop until the light changes to a flashing yellow light."
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q160.png"
    }
  },
  {
    "@id": "161",
    "text": "A flashing yellow traffic light means:",
    "answers": {
      "answer": "Slow down and be prepared to stop.",
      "distractor_1": "The light is about to change to red.",
      "distractor_2": "Stop.",
      "distractor_3": "The light is about to change to green."
    },
    "chapter": "Chapter 3: Signs, Signals and Road Markings",
    "source": [],
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers3.pdf"
    },
    "image": {
      "@file": "images/opkt/q161.png"
    }
  },
  {
    "@id": "162",
    "text": "If you are in the Graduated Licensing Program (GLP), are you allowed to use a GPS navigation device while driving?",
    "answers": {
      "answer": "No, using a GPS as an electronic device can be a distraction.",
      "distractor_1": "Only if the destination is programmed into the GPS before driving.",
      "distractor_2": "Only if the GPS device is guiding you by audio (i.e. on speaker).",
      "distractor_3": "Only when stopped such as at a red traffic light."
    },
    "chapter": "Chapter 7: Personal strategies",
    "source": "GLP drivers are restricted from operating hands-free electronic devices while driving.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers7.pdf"
    }
  },
  {
    "@id": "163",
    "text": "While driving, a hand held device may be used to…",
    "answers": {
      "answer": "none of these are allowed.",
      "distractor_1": "view an email or text.",
      "distractor_2": "select songs on your vehicle's audio system.",
      "distractor_3": "check for directions via GPS."
    },
    "chapter": "Chapter 7: Personal strategies",
    "source": "You can use your phone to dial 911 in an emergency only. Using your cell phone without a hands-free device while driving in any other situation is illegal and will result in penalties and fines.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers7.pdf"
    }
  },
  {
    "@id": "164",
    "text": "I am allowed to check text messages in my vehicle…",
    "answers": {
      "answer": "when the vehicle is safely parked off the roadway.",
      "distractor_1": "when stopped at a red traffic light.",
      "distractor_2": "when stopped in heavy traffic.",
      "distractor_3": "all of these are allowed."
    },
    "chapter": "Chapter 7: Personal strategies",
    "source": "If you do need to make or receive a call, pull over as soon as it's safe to do so; stay focused on the road and keep the conversation brief.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers7.pdf"
    }
  },
  {
    "@id": "165",
    "text": "As a Class 7 L or N driver, I am allowed to use my hands free device while driving…",
    "answers": {
      "answer": "for emergency calls only.",
      "distractor_1": "for skipping through music tracks when connected to my vehicle's audio system.",
      "distractor_2": "to check the map on GPS.",
      "distractor_3": "never."
    },
    "chapter": "Chapter 7: Personal strategies",
    "source": "You can use your phone to dial 911 in an emergency only. Using your cell phone without a hands-free device while driving in any other situation is illegal and will result in penalties and fines.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers7.pdf"
    }
  },
  {
    "@id": "166",
    "text": "You're driving at the speed limit in the left lane of an 80km/h multi-lane highway. A car approaches from behind. You must:",
    "answers": {
      "answer": "safely pull into to nearest lane on your right to let the other vehicle pass.",
      "distractor_1": "maintain your lane position.",
      "distractor_2": "increase your speed to match the vehicle behind you.",
      "distractor_3": "slow down to give yourself more space to safely brake."
    },
    "chapter": "Chapter 4: Rules of the road",
    "source": "When on a multi-lane highway with a posted speed limit above 80km/h and traffic moving at least 50km/h, you must avoid using the left lane if it blocks other drivers from passing. Drivers who block the left lane increase the risk caused by aggressive drivers who may try to pass on the right or tailgate.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    },
    "image": {
      "@file": "images/opkt/q166.png"
    }
  },
  {
    "@id": "167",
    "text": "You're driving 90km/h in the left lane of a multi-lane highway in a rural area. Must you move over to the right?",
    "answers": {
      "answer": "Unless any vehicle approaches from behind, you may stay in the left lane to keep a greater distance from any wildlife on the road.",
      "distractor_1": "You're always required to keep right on high speed roads unless passing.",
      "distractor_2": "You may stay in the left lane as long as you're driving at the speed limit.",
      "distractor_3": "Only if emergency vehicles with flashing lights are approaching you from behind."
    },
    "chapter": "Chapter 4: Rules of the road",
    "source": "If there's no traffic behind you it is permitted to drive in the left lane.  On rural roads it is sometimes safer to stay in the left to avoid wildlife near the highway.  When a vehicle approaches from behind move over to the right to let them pass.",
    "link": {
      "@src": "http://www.icbc.com/driver-licensing/Documents/drivers4.pdf"
    },
    "image": {
      "@file": "images/opkt/q167.png"
    }
  },
  {
    "@id": "168",
    "text": "Can I listen to music from my electronic device while driving?",
    "answers": {
      "answer": "Yes, you can listen to music from an electronic device while driving, provided that it is connected to the in-vehicle audio system, and you don't touch any electronic devices while operating the vehicle.",
      "distractor_1": "Yes, you can listen to music from an electronic device while driving, provided that you are wearing earbuds or an ear piece",
      "distractor_2": "No, you may not connect your electronic device in advance and listen to music with your in-vehicle system.",
      "distractor_3": "Yes, you can listen to music from an electronic device while driving, as long as the device is securely attached to the vehicle's dashboard."
    },
    "chapter": "Chapter 7: Personal Strategies; Keeping Focused",
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": ""
    }
  },
  {
    "@id": "169",
    "text": "Which of the following would not qualify as an emergency call that I can make while driving?",
    "answers": {
      "answer": "To a family member",
      "distractor_1": "To the police",
      "distractor_2": "To the fire department",
      "distractor_3": "To ambulance services"
    },
    "chapter": "Chapter 7: Personal Strategies; Keeping Focused",
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": ""
    }
  },
  {
    "@id": "170",
    "text": "When can I use a personal electronic device if I'm in the Graduated Licensing Program (GLP)?",
    "answers": {
      "answer": "None of the above - I cannot use a personal electronic device in the GLP",
      "distractor_1": "I've been in the program for at least six months",
      "distractor_2": "I've secured my cell phone to the vehicle",
      "distractor_3": "I'm using a speaker phone or hands-free phone"
    },
    "chapter": "Chapter 7: Personal Strategies; Keeping Focused",
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": ""
    }
  },
  {
    "@id": "171",
    "text": "If I am at a red light or stopped in traffic, can I look at a text I just received?",
    "answers": {
      "answer": "No, you may not operate your cell phone while on the road including when you're stopped in traffic.",
      "distractor_1": "Yes, you can quickly look at your screen but not reply to any messages.",
      "distractor_2": "Yes, whenever a vehicle is not moving means you're not driving.",
      "distractor_3": "Yes, as long as the light has just turned red. You have about a minute to safely use your phone."
    },
    "chapter": "Chapter 7: Personal Strategies; Keeping Focused",
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": ""
    }
  }
]
// https://practicetest.icbc.com/data/signs/english.xml
const questionsSign = [
  {
    "@id": "1",
    "text": "Black signs with white arrows indicate",
    "answers": {
      "answer": "which way you may go in your lane.",
      "distractor_1": "which way you may go at an intersection.",
      "distractor_2": "a vehicle carrying hazardous goods.",
      "distractor_3": "information about local roads and distances."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/1.gif"
    }
  },
  {
    "@id": "2",
    "text": "This sign means:",
    "answers": {
      "answer": "A lower speed limit ahead.",
      "distractor_1": "This speed limit is ending.",
      "distractor_2": "The maximum speed you are currently allowed to travel.",
      "distractor_3": "No turns for the next 50 kilometers."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/2.gif"
    }
  },
  {
    "@id": "3",
    "text": "This sign means:",
    "answers": {
      "answer": "Keep right of the divider.",
      "distractor_1": "Divided highway ends.",
      "distractor_2": "Curve to the right ahead.",
      "distractor_3": "Change lanes to the right."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/3.gif"
    }
  },
  {
    "@id": "4",
    "text": "This sign:",
    "answers": {
      "answer": "Indicates a pedestrian crosswalk.",
      "distractor_1": "Indicates a school crosswalk.",
      "distractor_2": "Signals pedestrians to walk.",
      "distractor_3": "Warns of people on the road."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/4.gif"
    }
  },
  {
    "@id": "5",
    "text": "This sign indicates that:",
    "answers": {
      "answer": "The curb lane of the cross street ahead is a reserved lane.",
      "distractor_1": "There is an extended sidewalk at the intersection.",
      "distractor_2": "Buses turning right must merge from the lane with the diamond shape.",
      "distractor_3": "Buses only may turn right."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/5.gif"
    }
  },
  {
    "@id": "6",
    "text": "This sign means:",
    "answers": {
      "answer": "Winding road ahead.",
      "distractor_1": "Road may be slippery ahead.",
      "distractor_2": "Slippery railroad tracks ahead.",
      "distractor_3": "The road ahead crosses over a river."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/6.gif"
    }
  },
  {
    "@id": "7",
    "text": "This sign means:",
    "answers": {
      "answer": "Roundabout ahead.",
      "distractor_1": "U-turns ahead.",
      "distractor_2": "Do not enter.",
      "distractor_3": "You must turn ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/7.gif"
    }
  },
  {
    "@id": "8",
    "text": "This sign means:",
    "answers": {
      "answer": "School crosswalk ahead.",
      "distractor_1": "Children on road.",
      "distractor_2": "Pedestrian crosswalk ahead.",
      "distractor_3": "White cane crossing ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/8.gif"
    }
  },
  {
    "@id": "9",
    "text": "This sign indicates:",
    "answers": {
      "answer": "The recommended exit speed - drive slower in poor conditions.",
      "distractor_1": "Slow down to this speed if you are being passed.",
      "distractor_2": "Slow down to this speed to allow other drivers to exit the highway.",
      "distractor_3": "All traffic must slow down to this speed."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/9.gif"
    }
  },
  {
    "@id": "10",
    "text": "This marker indicates:",
    "answers": {
      "answer": "An obstruction - keep left or right.",
      "distractor_1": "You must go in the direction of the lighted arrow.",
      "distractor_2": "Dead end street - turn left or right.",
      "distractor_3": "Two way road ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/10.gif"
    }
  },
  {
    "@id": "11",
    "text": "This light means:",
    "answers": {
      "answer": "You must go in the direction of the lighted arrow.",
      "distractor_1": "You may go to the left or the right.",
      "distractor_2": "Dead end street - turn left or right.",
      "distractor_3": "Two way road ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/11.gif"
    }
  },
  {
    "@id": "12",
    "text": "This flashing red 'X' in this light indicates:",
    "answers": {
      "answer": "Do not drive in this lane.",
      "distractor_1": "Stop as you would as a stop sign.",
      "distractor_2": "Bridge ahead is closed to allow ships to pass.",
      "distractor_3": "Use caution in this lane."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/12.gif"
    }
  },
  {
    "@id": "13",
    "text": "This flashing green arrow means:",
    "answers": {
      "answer": "You may drive in this lane.",
      "distractor_1": "Pedestrian controlled traffic light.",
      "distractor_2": "Be prepared for the light to turn yellow.",
      "distractor_3": "One way traffic only."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/13.gif"
    }
  },
  {
    "@id": "14",
    "text": "A traffic light showing a flashing green arrow with a steady green light indicates:",
    "answers": {
      "answer": "You may turn in the direction of the arrow or proceed through.",
      "distractor_1": "You may turn left but yield to oncoming traffic.",
      "distractor_2": "You may merge into the left hand lane.",
      "distractor_3": "You may turn left on to a one way street."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/14.gif"
    }
  },
  {
    "@id": "15",
    "text": "This steady green light with a solid yellow arrow indicates:",
    "answers": {
      "answer": "The protected left turn signal is about to change and oncoming traffic will be facing a steady green light.",
      "distractor_1": "You should speed up slightly to ensure you make it through the light.",
      "distractor_2": "You will not be allowed to turn left at this intersection until the arrow re-appears.",
      "distractor_3": "All traffic must slow down and stop unless you can not safely stop in time."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/15.gif"
    }
  },
  {
    "@id": "16",
    "text": "A single yellow broken line indicates:",
    "answers": {
      "answer": "Traffic moving in opposite directions - passing is allowed when safe.",
      "distractor_1": "Two lanes of traffic moving in the same direction - changing lanes is allowed when safe.",
      "distractor_2": "No passing allowed.",
      "distractor_3": "No turns allowed across the broken line."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/16.gif"
    }
  },
  {
    "@id": "17",
    "text": "A broken yellow line along with a solid yellow line indicates:",
    "answers": {
      "answer": "You may pass if the broken line is on your side and only when it is safe.",
      "distractor_1": "Vehicles travelling in both directions may pass when safe.",
      "distractor_2": "You may pass if the solid line is on your side and only when it is safe.",
      "distractor_3": "No passing permitted."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/17.gif"
    }
  },
  {
    "@id": "18",
    "text": "A solid single yellow line indicates:",
    "answers": {
      "answer": "Passing allowed with extra caution.",
      "distractor_1": "No passing is allowed.",
      "distractor_2": "Turns are not permitted.",
      "distractor_3": "A bicycle lane to the right."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/18.gif"
    }
  },
  {
    "@id": "19",
    "text": "The white line in this diagram indicates:",
    "answers": {
      "answer": "A stop line - stop before this line.",
      "distractor_1": "A speed bump - slow down in this area.",
      "distractor_2": "Watch for children on the road.",
      "distractor_3": "No parking past the white line."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/19.gif"
    }
  },
  {
    "@id": "20",
    "text": "These white lines across a road indicate:",
    "answers": {
      "answer": "A crosswalk.",
      "distractor_1": "Where you must stop before the intersection.",
      "distractor_2": "A speed bump - slow down.",
      "distractor_3": "An obstruction ahead - slow down."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/20.gif"
    }
  },
  {
    "@id": "21",
    "text": "When you see flashing yellow lights in the road by these white lines:",
    "answers": {
      "answer": "It indicates a pedestrian activated crosswalk - stop for pedestrians in the crosswalk.",
      "distractor_1": "Stop as you would at a stop sign.",
      "distractor_2": "Be prepared for the flashing lights to turn red.",
      "distractor_3": "It indicates a pedestrian activated crosswalk - you must stop before the crosswalk."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/21.gif"
    }
  },
  {
    "@id": "22",
    "text": "This diamond shape road marking means:",
    "answers": {
      "answer": "Reserved lane - additional markings will indicate which vehicles are allowed.",
      "distractor_1": "Bus lane only - all other vehicles are prohibited.",
      "distractor_2": "Emergency vehicles only - do not block lane.",
      "distractor_3": "Bicycles only."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/22.gif"
    }
  },
  {
    "@id": "23",
    "text": "The marking on the right of the road ahead indicates:",
    "answers": {
      "answer": "A bicycle lane for cyclists only.",
      "distractor_1": "Vehicles may not use lane if bicyclists present.",
      "distractor_2": "Motorcycles only in this lane.",
      "distractor_3": "Cyclist crossing area - be prepared to stop."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/23.gif"
    }
  },
  {
    "@id": "24",
    "text": "Road markings. This arrow indicates:",
    "answers": {
      "answer": "Vehicles in this lane must turn left.",
      "distractor_1": "U-turn ahead.",
      "distractor_2": "Merge to the left lane.",
      "distractor_3": "Left turn traffic light ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/24.gif"
    }
  },
  {
    "@id": "25",
    "text": "Road markings. These yellow markings on the road mean:",
    "answers": {
      "answer": "Painted Island - keep to the right and do not drive on or over the markings.",
      "distractor_1": "Two way left turn lane - move into the yellow area to turn.",
      "distractor_2": "Extended left turn lane - you may drive over the markings  if rest of left lane full.",
      "distractor_3": "Emergency pullout area - pull over to the yellow area and display hazard lights."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/25.gif"
    }
  },
  {
    "@id": "26",
    "text": "This sign means:",
    "answers": {
      "answer": "Sharp curve to the right ahead - slow down.",
      "distractor_1": "Intersection ahead - slow down.",
      "distractor_2": "Right turn only at this intersection.",
      "distractor_3": "Obstruction ahead - slow down and move to the right."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/26.gif"
    }
  },
  {
    "@id": "27",
    "text": "This sign means:",
    "answers": {
      "answer": "Merging traffic ahead.",
      "distractor_1": "Two lanes reduced to one lane ahead.",
      "distractor_2": "Yield to all traffic on the right.",
      "distractor_3": "Concealed lane ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/27.gif"
    }
  },
  {
    "@id": "28",
    "text": "This sign means:",
    "answers": {
      "answer": "Right lane ends ahead.",
      "distractor_1": "Divided highway ends.",
      "distractor_2": "Road narrows ahead.",
      "distractor_3": "Lane narrows ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/28.gif"
    }
  },
  {
    "@id": "29",
    "text": "This sign means:",
    "answers": {
      "answer": "Obstruction - keep right.",
      "distractor_1": "Obstruction - keep left or right.",
      "distractor_2": "Dead end.",
      "distractor_3": "Construction ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/29.gif"
    }
  },
  {
    "@id": "30",
    "text": "This sign means:",
    "answers": {
      "answer": "Yield the right of way to other traffic.",
      "distractor_1": "Stop as you would at a stop sign.",
      "distractor_2": "Slow moving vehicle.",
      "distractor_3": "vehicle carrying hazardous materials."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/30.gif"
    }
  },
  {
    "@id": "31",
    "text": "This sign means:",
    "answers": {
      "answer": "Do not enter.",
      "distractor_1": "One way street.",
      "distractor_2": "Stop, as you would at a stop sign.",
      "distractor_3": "Dead end street."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/31.gif"
    }
  },
  {
    "@id": "32",
    "text": "This sign means:",
    "answers": {
      "answer": "Pedestrian controlled crosswalk - if light is flashing be prepared to stop.",
      "distractor_1": "Pedestrian controlled crosswalk - if light is steady yellow you may proceed.",
      "distractor_2": "Pedestrian crosswalk - stop as you would at a stop sign.",
      "distractor_3": "School zone - stop if lights flashing."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/32.gif"
    }
  },
  {
    "@id": "33",
    "text": "When must you observe this speed limit?",
    "answers": {
      "answer": "8 a.m. to 5 p.m. on regular school days.",
      "distractor_1": "Dawn to dusk every day.",
      "distractor_2": "Whenever children are on the road.",
      "distractor_3": "Every weekday from dawn to dusk."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/33.gif"
    }
  },
  {
    "@id": "34",
    "text": "This sign means:",
    "answers": {
      "answer": "Two way left turn lane.",
      "distractor_1": "Left and right turns allowed at this intersection.",
      "distractor_2": "Two way traffic ahead.",
      "distractor_3": "Left turns only at this intersection."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/34.gif"
    }
  },
  {
    "@id": "35",
    "text": "This sign means:",
    "answers": {
      "answer": "No right turn at this intersection.",
      "distractor_1": "No right turn from this lane.",
      "distractor_2": "Left turn only at this intersection.",
      "distractor_3": "Dead end street."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/35.gif"
    }
  },
  {
    "@id": "36",
    "text": "This sign means:",
    "answers": {
      "answer": "No left turn at this intersection.",
      "distractor_1": "The lane ends ahead - turn left.",
      "distractor_2": "Do not move into the left lane.",
      "distractor_3": "Left turn only at this intersection."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/36.gif"
    }
  },
  {
    "@id": "37",
    "text": "This sign means:",
    "answers": {
      "answer": "No turns permitted at this intersection.",
      "distractor_1": "Yield to traffic in intersection.",
      "distractor_2": "One way traffic only.",
      "distractor_3": "No lane changes allowed."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/37.gif"
    }
  },
  {
    "@id": "38",
    "text": "This sign means:",
    "answers": {
      "answer": "Trucks may be crossing ahead.",
      "distractor_1": "Trucks slow down - slippery road ahead.",
      "distractor_2": "Truck lane ahead.",
      "distractor_3": "Slow moving trucks ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/38.gif"
    }
  },
  {
    "@id": "39",
    "text": "This sign means:",
    "answers": {
      "answer": "Hidden intersection or side road ahead.",
      "distractor_1": "Truck crossing ahead.",
      "distractor_2": "Stop at hidden intersection ahead.",
      "distractor_3": "Obstruction ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/39.gif"
    }
  },
  {
    "@id": "40",
    "text": "This sign means:",
    "answers": {
      "answer": "Hazard ahead, slow down and turn right or left.",
      "distractor_1": "Park on either the left or the right.",
      "distractor_2": "Detour - construction ahead.",
      "distractor_3": "No turns allowed."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/40.gif"
    }
  },
  {
    "@id": "41",
    "text": "This sign means:",
    "answers": {
      "answer": "The road may be slippery when wet.",
      "distractor_1": "The road is winding.",
      "distractor_2": "Watch for oil slicks on road.",
      "distractor_3": "Skidding likely in this area at all times."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/41.gif"
    }
  },
  {
    "@id": "42",
    "text": "This sign means slow to 30 km/h:",
    "answers": {
      "answer": "Every day from dawn to dusk.",
      "distractor_1": "Weekdays from dawn to dusk.",
      "distractor_2": "When you see children on road.",
      "distractor_3": "Weekends from dawn to dusk."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/42.gif"
    }
  },
  {
    "@id": "43",
    "text": "This sign means:",
    "answers": {
      "answer": "Playground nearby - drive with caution",
      "distractor_1": "Sports stadium nearby - watch for hazards.",
      "distractor_2": "Slow to 30 km/h if pedestrians crossing.",
      "distractor_3": "School crosswalk - stop for pedestrians."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/43.gif"
    }
  },
  {
    "@id": "44",
    "text": "This sign means:",
    "answers": {
      "answer": "The pavement ends ahead.",
      "distractor_1": "Road construction ahead.",
      "distractor_2": "No road past this point.",
      "distractor_3": "Dead end ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/44.gif"
    }
  },
  {
    "@id": "45",
    "text": "This sign means:",
    "answers": {
      "answer": "There is road construction ahead.",
      "distractor_1": "The end of a construction zone.",
      "distractor_2": "The start of a construction zone - you must obey the traffic control person.",
      "distractor_3": "Construction ahead - do not enter."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/45.gif"
    }
  },
  {
    "@id": "46",
    "text": "This sign means:",
    "answers": {
      "answer": "Obey this speed limit at all times throughout the construction zone.",
      "distractor_1": "Obey this speed limit when the construction crew is working.",
      "distractor_2": "Crew and equipment are working and you must obey the speed sign from 8 a.m. to 5 p.m.",
      "distractor_3": "You must obey the speed sign on weekdays."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/46.gif"
    }
  },
  {
    "@id": "47",
    "text": "A flashing red light means:",
    "answers": {
      "answer": "Stop and proceed when it is safe to do so.",
      "distractor_1": "Slow down and proceed through intersection if safe.",
      "distractor_2": "Stop until the light changes to a flashing green light.",
      "distractor_3": "Stop until the light changes to a flashing yellow light."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/47.gif"
    }
  },
  {
    "@id": "48",
    "text": "A steady green arrow means:",
    "answers": {
      "answer": "You may turn in the direction of the arrow if the intersection is clear.",
      "distractor_1": "You may turn in the direction of the arrow after coming to a complete stop.",
      "distractor_2": "The cross-street is a one way street in the direction of the arrow.",
      "distractor_3": "You may only turn left at this intersection."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/48.gif"
    }
  },
  {
    "@id": "49",
    "text": "A steady red light means:",
    "answers": {
      "answer": "Stop. After coming to a full stop you may turn right or turn left onto a one-way street unless a sign forbids it.",
      "distractor_1": "Stop if traffic is approaching.",
      "distractor_2": "Stop, then proceed when safe.",
      "distractor_3": "You must stop unless you are turning right."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/49.gif"
    }
  },
  {
    "@id": "50",
    "text": "A steady green light means:",
    "answers": {
      "answer": "You may proceed if the intersection is clear.",
      "distractor_1": "Turns are allowed at this intersection.",
      "distractor_2": "Slow down and proceed with caution.",
      "distractor_3": "You may drive in this lane."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/50.gif"
    }
  },
  {
    "@id": "51",
    "text": "A flashing yellow traffic light means:",
    "answers": {
      "answer": "Slow down and be prepared to stop.",
      "distractor_1": "The light is about to change to red.",
      "distractor_2": "Stop.",
      "distractor_3": "The light is about to change to green."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/51.gif"
    }
  },
  {
    "@id": "52",
    "text": "A flashing green light means:",
    "answers": {
      "answer": "The traffic signals are controlled by pedestrians.",
      "distractor_1": "The light is about to change to red.",
      "distractor_2": "Opposing traffic is facing a red light.",
      "distractor_3": "You may drive in the lane below the light."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/52.gif"
    }
  },
  {
    "@id": "53",
    "text": "A flashing green arrow with a steady red light means:",
    "answers": {
      "answer": "You may turn left.",
      "distractor_1": "No left turn at any time.",
      "distractor_2": "The cross-street is a one way street in the direction of the arrow.",
      "distractor_3": "Wait until the red light turns green before turning left."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/53.gif"
    }
  },
  {
    "@id": "54",
    "text": "The centre lane in this diagram:",
    "answers": {
      "answer": "Is shared by vehicles travelling in opposite direction when making left turns.",
      "distractor_1": "May be used to stop to answer your cell phone.",
      "distractor_2": "May be used for emergency vehicles only.",
      "distractor_3": "Indicates an intersection with a turn ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/54.gif"
    }
  },
  {
    "@id": "55",
    "text": "A steady yellow light means:",
    "answers": {
      "answer": "Stop unless it is unsafe to do so.",
      "distractor_1": "Slow down but proceed.",
      "distractor_2": "Stop and then proceed.",
      "distractor_3": "Stop only if there are other vehicles in the intersection."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/55.gif"
    }
  },
  {
    "@id": "56",
    "text": "This sign means:",
    "answers": {
      "answer": "One-way traffic.",
      "distractor_1": "Traffic straight through only.",
      "distractor_2": "Right turn at this intersection.",
      "distractor_3": "Merge right."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/56.gif"
    }
  },
  {
    "@id": "57",
    "text": "This sign means:",
    "answers": {
      "answer": "Narrow structure ahead.",
      "distractor_1": "Two lanes merging.",
      "distractor_2": "Narrow road ahead.",
      "distractor_3": "One way traffic ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/57.gif"
    }
  },
  {
    "@id": "58",
    "text": "This sign means:",
    "answers": {
      "answer": "Watch for fallen rock or landslide obstructing traffic.",
      "distractor_1": "Construction blasting zone ahead.",
      "distractor_2": "Watch for truck spills.",
      "distractor_3": "Loose gravel ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/58.gif"
    }
  },
  {
    "@id": "59",
    "text": "This sign means:",
    "answers": {
      "answer": "You are approaching a slow moving vehicle.",
      "distractor_1": "Yield the right of way.",
      "distractor_2": "You are approaching a disabled vehicle by the side of the road.",
      "distractor_3": "You are in a construction zone."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/59.gif"
    }
  },
  {
    "@id": "60",
    "text": "This sign means:",
    "answers": {
      "answer": "Underpass (or structure) ahead. Overhead clearance as shown.",
      "distractor_1": "Road narrows to 3.8 metres.",
      "distractor_2": "No turns for the next 3.8 miles.",
      "distractor_3": "No vehicles above this height allowed on road."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/60.gif"
    }
  },
  {
    "@id": "61",
    "text": "This sign means:",
    "answers": {
      "answer": "Divided highway ends ahead - keep right.",
      "distractor_1": "Divided highway start - keep right.",
      "distractor_2": "Passing permitted.",
      "distractor_3": "Tunnel ends ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/61.gif"
    }
  },
  {
    "@id": "62",
    "text": "A square or rectangular sign with a white background:",
    "answers": {
      "answer": "Shows driving regulations.",
      "distractor_1": "Warns of hazards ahead.",
      "distractor_2": "Shows distance and direction.",
      "distractor_3": "Shows lane use."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/62.gif"
    }
  },
  {
    "@id": "63",
    "text": "Diamond-shaped signs with a YELLOW background:",
    "answers": {
      "answer": "Warn of hazards ahead.",
      "distractor_1": "Show driving regulations.",
      "distractor_2": "Warn of road construction ahead.",
      "distractor_3": "Warn of a school zone ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/63.gif"
    }
  },
  {
    "@id": "64",
    "text": "Diamond-shaped signs with an ORANGE background:",
    "answers": {
      "answer": "Warn of construction zones.",
      "distractor_1": "Show driving regulations.",
      "distractor_2": "Show lane use.",
      "distractor_3": "Show motorist services."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/64.gif"
    }
  },
  {
    "@id": "65",
    "text": "This sign:",
    "answers": {
      "answer": "Shows a permitted action.",
      "distractor_1": "Shows an action that is not permitted.",
      "distractor_2": "Shows lane use.",
      "distractor_3": "Warns of a school zone."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/65.gif"
    }
  },
  {
    "@id": "66",
    "text": "This sign means:",
    "answers": {
      "answer": "Vehicles in both lanes must turn left.",
      "distractor_1": "There is a curve to the left ahead.",
      "distractor_2": "Keep to the left of the divider.",
      "distractor_3": "Both lanes curve to the left ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/66.gif"
    }
  },
  {
    "@id": "67",
    "text": "This signal with a steady green arrow means:",
    "answers": {
      "answer": "No turn permitted - go straight through only.",
      "distractor_1": "Drive in this lane only.",
      "distractor_2": "Pedestrian controlled intersection.",
      "distractor_3": "Transit priority signal."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/67.gif"
    }
  },
  {
    "@id": "68",
    "text": "This sign means:",
    "answers": {
      "answer": "Bumps or rough road ahead - slow down.",
      "distractor_1": "Industrial area ahead.",
      "distractor_2": "Steep hills ahead.",
      "distractor_3": "Danger - road ends ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/68.gif"
    }
  },
  {
    "@id": "69",
    "text": "The signal above this solid red light means:",
    "answers": {
      "answer": "Only buses may go on this signal.",
      "distractor_1": "Public transit buses may not proceed.",
      "distractor_2": "All traffic must stop - emergency vehicles approaching.",
      "distractor_3": "Yield to public transit buses - then proceed."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/69.gif"
    }
  },
  {
    "@id": "70",
    "text": "This sign means:",
    "answers": {
      "answer": "Cyclists may be on roadway.",
      "distractor_1": "Bicycle lane ahead.",
      "distractor_2": "Bicycles prohibited.",
      "distractor_3": "Do not pass cyclists."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/70.gif"
    }
  },
  {
    "@id": "71",
    "text": "This sign means:",
    "answers": {
      "answer": "Do not pass.",
      "distractor_1": "There is only single lane traffic ahead.",
      "distractor_2": "The road is for one way traffic only.",
      "distractor_3": "There is a divided road ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/71.gif"
    }
  },
  {
    "@id": "72",
    "text": "This sign means:",
    "answers": {
      "answer": "Only buses and high occupancy vehicles in this lane.",
      "distractor_1": "Only buses in this lane.",
      "distractor_2": "Area for buses and taxis only.",
      "distractor_3": "Public transit lane only."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/72.gif"
    }
  },
  {
    "@id": "73",
    "text": "This sign means:",
    "answers": {
      "answer": "The fastest you may drive under ideal conditions.",
      "distractor_1": "That there is a faster speed limit ahead.",
      "distractor_2": "The ideal speed for this road in any condition.",
      "distractor_3": "The maximum speed unless you are passing."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/73.gif"
    }
  },
  {
    "@id": "74",
    "text": "This signal over a lane means:",
    "answers": {
      "answer": "Move out of this lane and into the lane with the green arrow.",
      "distractor_1": "Do not drive in this lane.",
      "distractor_2": "This lane is under construction.",
      "distractor_3": "This lane is about to open."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/74.gif"
    }
  },
  {
    "@id": "75",
    "text": "This sign means:",
    "answers": {
      "answer": "Obstruction - keep left.",
      "distractor_1": "Obstruction ahead - keep right.",
      "distractor_2": "Do not enter.",
      "distractor_3": "Danger road ends ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/75.gif"
    }
  },
  {
    "@id": "76",
    "text": "This sign means:",
    "answers": {
      "answer": "Railway crossing ahead - be prepared to stop.",
      "distractor_1": "There are no warning lights.",
      "distractor_2": "You may drive straight across the railway crossing.",
      "distractor_3": "The railway crossing is no longer in use."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/76.gif"
    }
  },
  {
    "@id": "77",
    "text": "This sign means:",
    "answers": {
      "answer": "Road narrows ahead.",
      "distractor_1": "Divided highway ends ahead.",
      "distractor_2": "Lane ends ahead.",
      "distractor_3": "Narrow structure ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/77.gif"
    }
  },
  {
    "@id": "78",
    "text": "This sign means:",
    "answers": {
      "answer": "School crosswalk, yield to pedestrians; if there is a crossing guard follow directions.",
      "distractor_1": "Pedestrian crosswalk.",
      "distractor_2": "School zone - reduce speed.",
      "distractor_3": "Playground area."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/78.gif"
    }
  },
  {
    "@id": "79",
    "text": "This sign warns:",
    "answers": {
      "answer": "School bus stop ahead.",
      "distractor_1": "An oncoming vehicle has its lights flashing.",
      "distractor_2": "A vehicle ahead has its hazard lights flashing.",
      "distractor_3": "A fire truck zone is ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/79.gif"
    }
  },
  {
    "@id": "80",
    "text": "This sign, without a speed tab below, means:",
    "answers": {
      "answer": "School zone - reduce speed when children are present.",
      "distractor_1": "Pedestrian crossing ahead.",
      "distractor_2": "School crossing ahead.",
      "distractor_3": "You must be prepared to stop at crosswalks controlled by crossing guards."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/80.gif"
    }
  },
  {
    "@id": "81",
    "text": "This sign means:",
    "answers": {
      "answer": "Steep hill ahead - slow or gear down.",
      "distractor_1": "Runaway vehicle lane ahead.",
      "distractor_2": "Truck stop ahead.",
      "distractor_3": "Truck route ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/81.gif"
    }
  },
  {
    "@id": "82",
    "text": "This sign means:",
    "answers": {
      "answer": "Stop sign ahead.",
      "distractor_1": "Proceed from this stop sign.",
      "distractor_2": "Be ready to stop ahead if necessary.",
      "distractor_3": "No turns ahead after stopping."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/82.gif"
    }
  },
  {
    "@id": "83",
    "text": "This sign means that in this lane, you must:",
    "answers": {
      "answer": "Turn left only.",
      "distractor_1": "Turn left or go straight ahead.",
      "distractor_2": "Turn right only.",
      "distractor_3": "Not turn left."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/83.gif"
    }
  },
  {
    "@id": "84",
    "text": "This sign warns:",
    "answers": {
      "answer": "Two-way traffic ahead.",
      "distractor_1": "Divided highway ahead.",
      "distractor_2": "Passing is prohibited ahead.",
      "distractor_3": "Passing is allowed ahead."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/84.gif"
    }
  },
  {
    "@id": "85",
    "text": "This sign means:",
    "answers": {
      "answer": "Stop completely - continue only when safe.",
      "distractor_1": "Stop or slow down if turning right.",
      "distractor_2": "Stop for pedestrians.",
      "distractor_3": "Slow down and stop if necessary."
    },
    "chapter": [],
    "source": [],
    "link": {
      "@src": ""
    },
    "image": {
      "@file": "images/signs/85.gif"
    }
  }
]

const tests = [
  { "id": "Full", questions: questionsFull },
  { "id": "Signs", questions: questionsSign },
]

document.title = 'ICBC Practice Test'
</script>

<style>
  .answer {
    background: lightgreen;
  }
  .source {
    font-size: .8em;
  }
  .distractor {
    color: lightgray;
  }
  li {
    padding: .4em;
  }
</style>

<p>Hey,</p>
<p>These are all the questions from <a href="https://practicetest.icbc.com">ICBC Practice Knowledge Test</a> website. Both <a href="#Full">Full test</a> and <a href="#Signs">Signs test</a>.</p>
<p>Good luck, <br>ushuz</p>
<!--
  P.S. This page is built with <a href="https://svelte.dev">Svelte</a>, and you can find the source code on <a href="https://github.com/ushuz/icbc-practice">GitHub</a>
-->

{#each tests as test }
<h1 id="{test.id}">{test.id} test</h1>
{#each test.questions as q, idx}
<div>
  {#if q['image']}
  <div><img src="https://practicetest.icbc.com/{q['image']['@file']}" alt=""></div>
  {/if}
  <h3>{idx+1}. {q.text}</h3>
  <ul>
    {#each Object.entries(q.answers) as [k, v]}
      <li class="{k === 'answer' ? k : 'distractor'}">
        <div>{v}</div>
        {#if k === 'answer' && (q.source.length || q.chapter.length) }
        <br>
        <div class="source">
          <div><a href="{q['link']['@src']}" target="_blank">{q.chapter}</a></div>
          <div>{q.source}</div>
        </div>
        {/if}
      </li>
    {/each}
  </ul>
</div>

<hr>
{/each}
{/each}
